/* tslint:disable */
/* eslint-disable */
/**
 * MWS.SportsService.WebApp | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AddAthleteToRosterRequest {
    'athleteId': string;
    'athleteRosterNumber'?: number | null;
}
export interface AdminAthleteLineupResponse {
    'id': string;
    'lineupId': string;
    'athleteId': string;
    'athlete'?: AdminAthleteResponse | null;
    'athleteLineupNumber'?: number | null;
    'position': string;
    'status': LineupStatus;
    'previousStatus'?: LineupStatus | null;
    'dateCreated': Date;
    'dateModified': Date;
    'createdBy': string;
    'modifiedBy': string;
}


export interface AdminAthleteResponse {
    'id': string;
    'name'?: string | null;
    'slug'?: string | null;
    'dateOfBirth'?: string | null;
    'placeOfBirth'?: string | null;
    'countryOfBirth'?: string | null;
    'defaultDisplayName'?: string | null;
    'nationality'?: string | null;
    'nationalityIso3Code'?: string | null;
    'position'?: string | null;
    'bio'?: string | null;
    'isArchived': boolean;
    'shirtName'?: string | null;
    'createdBy': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'externalId'?: string | null;
    'providerRecords': Array<ExternalProviderRecordResponse>;
}
export interface AdminAthleteRosterResponse {
    'id': string;
    'rosterId': string;
    'athleteId': string;
    'athleteRosterNumber'?: number | null;
    'athlete'?: AdminAthleteResponse | null;
    'isArchived': boolean;
    'isApproved': boolean;
    'shirtName'?: string | null;
    'dateCreated': Date;
    'dateModified': Date;
    'createdBy': string;
    'modifiedBy': string;
    'isTracked': boolean;
}
export interface AdminFixtureLineupStatusResponse {
    'id': string;
    'teamId': string;
    'confirmed': boolean;
    'finalized': boolean;
}
export interface AdminFixtureResponse {
    'id': string;
    'startDate': Date;
    'name'?: string | null;
    'status': string;
    'externalProvider': string;
    'venue'?: string | null;
    'score'?: string | null;
    'sportSlug'?: string | null;
    'seasonId'?: string | null;
    'externalId'?: string | null;
    'hasProviderRecord': boolean;
    'providerRecordCount': number;
    'dateCreated': Date;
    'dateModified': Date;
    'createdBy': string;
    'modifiedBy'?: string | null;
    'isLineupAutomaticCreationSupported': boolean;
    'teams': Array<AdminTeamResponse>;
    'lineupStatuses': Array<AdminFixtureLineupStatusResponse>;
}
export interface AdminLineupResponse {
    'id': string;
    'teamId': string;
    'team'?: AdminTeamResponse | null;
    'fixtureId': string;
    'fixture'?: AdminFixtureResponse | null;
    'athletesInLineup'?: Array<AdminAthleteLineupResponse> | null;
    'dateCreated': Date;
    'dateModified': Date;
    'createdBy': string;
    'modifiedBy': string;
}
export interface AdminRosterResponse {
    'id': string;
    'teamId': string;
    'team'?: AdminTeamResponse | null;
    'seasonId'?: string | null;
    'seasonLeague'?: AdminSeasonLeagueResponse | null;
    'dateCreated': Date;
    'dateModified': Date;
    'createdBy': string;
    'modifiedBy': string;
    'athletesInRoster'?: Array<AdminAthleteRosterResponse> | null;
    'lastSynced'?: Date | null;
    'isArchived': boolean;
    'sportSlug'?: string | null;
}
export interface AdminSeasonLeagueResponse {
    'seasonId': string;
    'leagueId': string;
    'name': string;
    'startDate'?: Date | null;
    'endDate'?: Date | null;
    'countryId'?: string | null;
    'countryIso3'?: string | null;
    'dateCreated': Date;
    'dateModified': Date;
    'createdBy': string;
    'modifiedBy': string;
}
export interface AdminSportDto {
    'id': string;
    'name': string;
    'slug': string;
    'dateCreated': Date;
    'createdBy': string;
    'modifiedBy': string;
    'dateModified': Date;
    'providerSlugs': Array<string>;
}
export interface AdminSportResponse {
    'id': string;
    'name': string;
    'slug': string;
    'isArchived': boolean;
    'createdBy': string;
    'dateCreated': Date;
    'modifiedBy'?: string | null;
    'dateModified'?: Date | null;
    'providerSlugs'?: Array<string> | null;
}
export interface AdminTeamResponse {
    'id': string;
    'name': string;
    'logoUrl'?: string | null;
    'foundedYear'?: number | null;
    'gender'?: string | null;
    'tier'?: number | null;
    'sportId'?: string | null;
    'countryId'?: string | null;
    'countryCode'?: string | null;
    'isArchived': boolean;
    'slug': string;
    'sportSlug'?: string | null;
    'createdBy': string;
    'dateCreated': Date;
    'modifiedBy'?: string | null;
    'dateModified'?: Date | null;
    'settings'?: TeamSettings | null;
    'providerRecords': Array<ExternalProviderRecordResponse>;
}
export interface ApproveRequest {
    'isApproved': boolean;
}
export interface ArchiveRequest {
    'isArchived': boolean;
}
export interface AthleteDetailsDto {
    'athleteId': string;
    'name'?: string | null;
    'details': { [key: string]: string; };
}
export interface AthleteDto {
    'id': string;
    'name'?: string | null;
    'slug'?: string | null;
    'dateOfBirth'?: string | null;
    'placeOfBirth'?: string | null;
    'countryOfBirth'?: string | null;
    'defaultDisplayName'?: string | null;
    'defaultLuckyNumber'?: number | null;
    'nationality'?: string | null;
    'position'?: string | null;
    'bio'?: string | null;
    'createdBy': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'providerRecords': Array<ExternalProviderRecordDto>;
    'mediaContentArray': Array<string>;
}
export interface AthleteLineupDto {
    'athleteId': string;
    'status': LineupStatus;
    'previousStatus'?: LineupStatus | null;
    'athleteLineupNumber'?: number | null;
    'dateCreated': Date;
    'athlete': AthleteDto;
}


export interface CategoryTeamsDto {
    'name': string;
    'countryIsoCode': string;
    'isCountryCategory': boolean;
    'teams': Array<TeamDto>;
}
export interface CountryDto {
    'id': string;
    'name': string;
    'iso': string;
    'continent': string;
}
export interface CountryTeamsDto {
    'teams': Array<TeamDto>;
    'id': string;
    'name': string;
    'iso': string;
    'continent': string;
}
export interface CreateAthleteLineupRequest {
    'rosterId': string;
}
export interface CreateAthleteRequest {
    'name': string;
    'shirtName': string;
}
export interface CreateLeagueRequest {
    'name'?: string | null;
    'isCup': boolean;
    'type'?: string | null;
    'countryId'?: string | null;
    'sportSlug'?: string | null;
}
export interface CreateManualFixtureRequest {
    'homeTeamId': string;
    'awayTeamId': string;
    'startDate': Date;
    'sportSlug': string;
}
export interface CreateOrGetFixtureRequestDto {
    'sportSlug': string;
    'startDate'?: Date | null;
    'endDate'?: Date | null;
    'homeTeamId'?: string | null;
    'awayTeamId'?: string | null;
    'createHomeTeam'?: CreateTeamRequestDto | null;
    'createAwayTeam'?: CreateTeamRequestDto | null;
    'externalId'?: string | null;
    'providerSlug'?: string | null;
}
export interface CreateSeasonRosterRequest {
    'teamId': string;
    'seasonId': string;
}
export interface CreateSportRequest {
    'name': string;
    'providerSlugs'?: Array<string> | null;
}
export interface CreateTeamRequest {
    'sportSlug': string;
    'teamName': string;
}
export interface CreateTeamRequestDto {
    'sportSlug'?: string | null;
    'teamName'?: string | null;
    'slug'?: string | null;
    'provider'?: string | null;
    'externalId'?: string | null;
    'externalLogoPath'?: string | null;
}
export interface ErrorResponse {
    'code': string;
    'message': string;
    'failures'?: Array<ValidationErrorDetails> | null;
}
export interface EventYieldTeamDto {
    'featuredTeamStadiumCapacity': number;
    'participatingTeamStadiumCapacity': number;
    'uefaPosition'?: number | null;
    'uefaPositionParticipatingTeam'?: number | null;
    'uefaRankingPoints'?: number | null;
    'fifaPosition'?: number | null;
    'areNationalTeams': boolean;
    'areRivals': boolean;
    'recentTransferValue': number;
    'transferValueParticipatingTeam': number;
    'transferValue1Year': number;
    'transferCount1Year': number;
    'numberOfTrophiesWon': number;
    'numberOfTrophiesWonParticipatingTeam': number;
    'numberOfTrophiesWon1Year': number;
    'numberOfTrophiesWon3Years': number;
    'continent'?: string | null;
    'featuredTeamCountry'?: string | null;
    'participatingTeamCountry'?: string | null;
    'gender': string;
    'squadSize'?: number | null;
    'uefaRankingBin': number;
    'fifaRankingBin': number;
}
export interface ExternalFixtureDto {
    'id': number;
    'winnerTeamId'?: number | null;
    'leagueId': string;
    'seasonId': string;
    'startDate': Date;
    'homeTeam': ExternalTeamDto;
    'awayTeam': ExternalTeamDto;
    'venue': ExternalVenueDto;
}
export interface ExternalProviderRecordDto {
    'providerSlug': string;
    'externalSyncStatus': string;
    'externalId': string;
    'externalLogoPath': string;
}
export interface ExternalProviderRecordResponse {
    'providerSlug': string;
    'externalSyncStatus': string;
    'externalId': string;
    'externalLogoPath': string;
}
export interface ExternalTeamDto {
    'id': string;
    'name': string;
    'shortCode': string;
    'countryId'?: number | null;
    'nationalTeam': boolean;
    'logoPath': string;
    'venueId'?: number | null;
    'currentSeasonId'?: number | null;
}
export interface ExternalVenueDto {
    'id': number;
    'name': string;
    'surface': string;
    'address': string;
    'city': string;
    'capacity'?: number | null;
    'imagePath': string;
}
export interface FixtureAggregateDto {
    'fixture': FixtureDto;
    'league'?: LeagueDto | null;
    'season'?: SeasonDto | null;
    'homeTeam': TeamDto;
    'awayTeam': TeamDto;
}
export interface FixtureDto {
    'id': string;
    'leagueId': string;
    'name': string;
    'status': string;
    'startDate': Date;
    'homeTeamId': string;
    'awayTeamId': string;
    'homeTeamName': string;
    'awayTeamName': string;
    'seasonId'?: string | null;
    'isArchived': boolean;
}
export interface LeagueDto {
    'id': string;
    'name': string;
    'countryId': string;
    'externalCountryId': string;
    'countryCode': string;
    'country': CountryDto;
    'isCup': boolean;
    'type': string;
    'seasons': Array<SeasonDto>;
    'createdBy': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'isArchived': boolean;
}
export interface LineupDto {
    'id': string;
    'team'?: TeamDto | null;
    'fixture'?: FixtureDto | null;
    'athleteLineups': Array<AthleteLineupDto>;
}

export enum LineupStatus {
    Benched = 'benched',
    Starting = 'starting',
    Subbedin = 'subbedin',
    Subbedout = 'subbedout',
    Removed = 'removed'
}


export interface PaginatedListOfAdminAthleteResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminAthleteResponse>;
}
export interface PaginatedListOfAdminAthleteRosterResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminAthleteRosterResponse>;
}
export interface PaginatedListOfAdminFixtureResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminFixtureResponse>;
}
export interface PaginatedListOfAdminRosterResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminRosterResponse>;
}
export interface PaginatedListOfAdminSportResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminSportResponse>;
}
export interface PaginatedListOfAdminTeamResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminTeamResponse>;
}
export interface PaginatedListOfAthleteDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AthleteDto>;
}
export interface PaginatedListOfLeagueDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<LeagueDto>;
}
export interface PaginatedListOfSeasonDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<SeasonDto>;
}
export interface PaginatedListOfTeamDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<TeamDto>;
}

export enum PublicMediaContentType {
    Banner = 'banner',
    EventBanner = 'eventBanner',
    Logo = 'logo'
}


export interface RosterDto {
    'id': string;
    'athletes': Array<AthleteDto>;
    'season'?: SeasonDto | null;
    'team': TeamDto;
    'lastSyncedOn'?: Date | null;
}
export interface SeasonDto {
    'id': string;
    'name': string;
    'startDate': Date;
    'endDate': Date;
    'league': LeagueDto;
    'fixtures': Array<FixtureDto>;
}

export enum SortAthleteOn {
    Name = 'name',
    Position = 'position',
    Nationality = 'nationality',
    DateOfBirth = 'dateOfBirth',
    BirthPlace = 'birthPlace',
    DefaultDisplayName = 'defaultDisplayName'
}



export enum SortDirection {
    Ascending = 'ascending',
    Descending = 'descending'
}



export enum SortFixtureOn {
    StartDate = 'startDate',
    DateCreated = 'dateCreated',
    DateModified = 'dateModified',
    SyncedOn = 'syncedOn',
    Status = 'status'
}



export enum SortSportOn {
    Name = 'name',
    Slug = 'slug',
    DateCreated = 'dateCreated'
}



export enum SortTeamOn {
    Name = 'name',
    Slug = 'slug',
    Tier = 'tier',
    Sport = 'sport',
    Country = 'country'
}


export interface TeamDto {
    'id': string;
    'name': string;
    'slug': string;
    'isDeleted': boolean;
    'heroBannerUrl'?: string | null;
    'eventBannerUrl'?: string | null;
    'logoUrl'?: string | null;
    'sportSlug'?: string | null;
    'gender'?: string | null;
    'foundedYear'?: number | null;
    'automaticColorUpdatesEnabled': boolean;
    'type'?: string | null;
    'teamColor'?: string | null;
    'countryCode'?: string | null;
    'createdBy': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'providerRecords': Array<ExternalProviderRecordDto>;
    'tier'?: number | null;
    'legacyIsPartner': boolean;
    'legacyCompetitionId'?: number | null;
    'legacyCompetitionName': string;
    'legacyCompetitionMenuOrder'?: number | null;
    'legacyClubMenuOrder'?: number | null;
    'settings'?: TeamSettingsDto | null;
    'country'?: CountryDto | null;
    'sport'?: AdminSportDto | null;
}
export interface TeamSettings {
    'preloadingEnabled': boolean;
    'preloadingCanBeEdited': boolean;
    'preloadingTimeInDays': number;
}
export interface TeamSettingsDto {
    'preloadingEnabled': boolean;
    'preloadingCanBeEdited': boolean;
    'preloadingTimeInDays': number;
}
export interface TeamsAggregateDto {
    'slug'?: string | null;
    'teams'?: Array<TeamDto> | null;
}
export interface UpdateAthleteRequestDto {
    'name'?: string | null;
    'slug'?: string | null;
    'dateOfBirth'?: string | null;
    'placeOfBirth'?: string | null;
    'countryOfBirth'?: string | null;
    'nationality'?: string | null;
    'defaultDisplayName'?: string | null;
    'bio'?: string | null;
    'shirtName'?: string | null;
    'position'?: string | null;
}
export interface UpdateAthleteRosterRequest {
    'athleteRosterNumber'?: number | null;
    'shirtName'?: string | null;
}
export interface UpdateFixtureRequest {
    'startDate'?: Date | null;
    'seasonId'?: string | null;
    'name'?: string | null;
    'venue'?: string | null;
    'score'?: string | null;
    'fixtureStatus'?: string | null;
    'sportSlug'?: string | null;
}
export interface UpdateLeagueRequest {
    'name'?: string | null;
    'isCup'?: boolean | null;
    'type'?: string | null;
    'countryId'?: string | null;
    'seasonIds'?: Array<string> | null;
}
export interface UpdateLineupAthlete {
    'id': string;
    'lineupNumber'?: number | null;
    'status': LineupStatus;
    'position'?: string | null;
}


export interface UpdateLineupWithAthletesRequest {
    'lineupAthletes': Array<UpdateLineupAthlete>;
}
export interface UpdateSportRequest {
    'name': string;
}
export interface UpdateTeamHeaderInfoRequest {
    'legacyIsPartner': boolean;
    'legacyCompetitionId'?: number | null;
    'legacyCompetitionName': string;
    'legacyCompetitionMenuOrder'?: number | null;
    'legacyClubMenuOrder'?: number | null;
    'country'?: CountryDto | null;
}
export interface UpdateTeamRequest {
    'teamName'?: string | null;
    'slug'?: string | null;
    'settings'?: UpdateTeamSettingsRequest | null;
    'gender'?: string | null;
    'sportSlug'?: string | null;
    'countryCode'?: string | null;
    'foundedYear'?: number | null;
    'tier'?: number | null;
}
export interface UpdateTeamSettingsRequest {
    'preloadingEnabled': boolean;
    'preloadingTimeInDays': number;
    'preloadingCanBeEdited': boolean;
}
export interface UploadMediaContentRequestDto {
    'imageUrl'?: string | null;
    'mediaContentType': PublicMediaContentType;
}


export interface ValidationErrorDetails {
    'errorCode': string;
    'errorMessage': string;
    'propertyName': string;
}
export interface ValidationFailure {
    'errorCode'?: string | null;
    'errorMessage'?: string | null;
    'propertyName'?: string | null;
}

/**
 * AdminAthleteRostersApi - axios parameter creator
 */
export const AdminAthleteRostersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approves the athlete under the roster
         * @param {string} rosterId 
         * @param {string} athleteId 
         * @param {ApproveRequest} approveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdAthletesAthleteIdApprovePatch: async (rosterId: string, athleteId: string, approveRequest: ApproveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rosterId' is not null or undefined
            assertParamExists('adminRostersRosterIdAthletesAthleteIdApprovePatch', 'rosterId', rosterId)
            // verify required parameter 'athleteId' is not null or undefined
            assertParamExists('adminRostersRosterIdAthletesAthleteIdApprovePatch', 'athleteId', athleteId)
            // verify required parameter 'approveRequest' is not null or undefined
            assertParamExists('adminRostersRosterIdAthletesAthleteIdApprovePatch', 'approveRequest', approveRequest)
            const localVarPath = `/admin/rosters/{rosterId}/athletes/{athleteId}/approve`
                .replace('{rosterId}', encodeURIComponent(String(rosterId)))
                .replace('{athleteId}', encodeURIComponent(String(athleteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archives the athlete under the roster
         * @param {string} rosterId 
         * @param {string} athleteId 
         * @param {ArchiveRequest} archiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdAthletesAthleteIdArchivePatch: async (rosterId: string, athleteId: string, archiveRequest: ArchiveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rosterId' is not null or undefined
            assertParamExists('adminRostersRosterIdAthletesAthleteIdArchivePatch', 'rosterId', rosterId)
            // verify required parameter 'athleteId' is not null or undefined
            assertParamExists('adminRostersRosterIdAthletesAthleteIdArchivePatch', 'athleteId', athleteId)
            // verify required parameter 'archiveRequest' is not null or undefined
            assertParamExists('adminRostersRosterIdAthletesAthleteIdArchivePatch', 'archiveRequest', archiveRequest)
            const localVarPath = `/admin/rosters/{rosterId}/athletes/{athleteId}/archive`
                .replace('{rosterId}', encodeURIComponent(String(rosterId)))
                .replace('{athleteId}', encodeURIComponent(String(athleteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(archiveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the athlete under the roster
         * @param {string} rosterId 
         * @param {string} athleteId 
         * @param {UpdateAthleteRosterRequest} updateAthleteRosterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdAthletesAthleteIdPatch: async (rosterId: string, athleteId: string, updateAthleteRosterRequest: UpdateAthleteRosterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rosterId' is not null or undefined
            assertParamExists('adminRostersRosterIdAthletesAthleteIdPatch', 'rosterId', rosterId)
            // verify required parameter 'athleteId' is not null or undefined
            assertParamExists('adminRostersRosterIdAthletesAthleteIdPatch', 'athleteId', athleteId)
            // verify required parameter 'updateAthleteRosterRequest' is not null or undefined
            assertParamExists('adminRostersRosterIdAthletesAthleteIdPatch', 'updateAthleteRosterRequest', updateAthleteRosterRequest)
            const localVarPath = `/admin/rosters/{rosterId}/athletes/{athleteId}`
                .replace('{rosterId}', encodeURIComponent(String(rosterId)))
                .replace('{athleteId}', encodeURIComponent(String(athleteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAthleteRosterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Getting the athletes under the roster
         * @param {string} rosterId 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {boolean} [isArchived] 
         * @param {string} [searchContent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdAthletesGet: async (rosterId: string, offSet?: number, pageSize?: number, isArchived?: boolean, searchContent?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rosterId' is not null or undefined
            assertParamExists('adminRostersRosterIdAthletesGet', 'rosterId', rosterId)
            const localVarPath = `/admin/rosters/{rosterId}/athletes`
                .replace('{rosterId}', encodeURIComponent(String(rosterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['isArchived'] = isArchived;
            }

            if (searchContent !== undefined) {
                localVarQueryParameter['searchContent'] = searchContent;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add an athlete to the roster
         * @param {string} rosterId 
         * @param {AddAthleteToRosterRequest} addAthleteToRosterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdAthletesPost: async (rosterId: string, addAthleteToRosterRequest: AddAthleteToRosterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rosterId' is not null or undefined
            assertParamExists('adminRostersRosterIdAthletesPost', 'rosterId', rosterId)
            // verify required parameter 'addAthleteToRosterRequest' is not null or undefined
            assertParamExists('adminRostersRosterIdAthletesPost', 'addAthleteToRosterRequest', addAthleteToRosterRequest)
            const localVarPath = `/admin/rosters/{rosterId}/athletes`
                .replace('{rosterId}', encodeURIComponent(String(rosterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAthleteToRosterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAthleteRostersApi - functional programming interface
 */
export const AdminAthleteRostersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAthleteRostersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approves the athlete under the roster
         * @param {string} rosterId 
         * @param {string} athleteId 
         * @param {ApproveRequest} approveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRostersRosterIdAthletesAthleteIdApprovePatch(rosterId: string, athleteId: string, approveRequest: ApproveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRostersRosterIdAthletesAthleteIdApprovePatch(rosterId, athleteId, approveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAthleteRostersApi.adminRostersRosterIdAthletesAthleteIdApprovePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archives the athlete under the roster
         * @param {string} rosterId 
         * @param {string} athleteId 
         * @param {ArchiveRequest} archiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRostersRosterIdAthletesAthleteIdArchivePatch(rosterId: string, athleteId: string, archiveRequest: ArchiveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRostersRosterIdAthletesAthleteIdArchivePatch(rosterId, athleteId, archiveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAthleteRostersApi.adminRostersRosterIdAthletesAthleteIdArchivePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates the athlete under the roster
         * @param {string} rosterId 
         * @param {string} athleteId 
         * @param {UpdateAthleteRosterRequest} updateAthleteRosterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRostersRosterIdAthletesAthleteIdPatch(rosterId: string, athleteId: string, updateAthleteRosterRequest: UpdateAthleteRosterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRostersRosterIdAthletesAthleteIdPatch(rosterId, athleteId, updateAthleteRosterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAthleteRostersApi.adminRostersRosterIdAthletesAthleteIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Getting the athletes under the roster
         * @param {string} rosterId 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {boolean} [isArchived] 
         * @param {string} [searchContent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRostersRosterIdAthletesGet(rosterId: string, offSet?: number, pageSize?: number, isArchived?: boolean, searchContent?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminAthleteRosterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRostersRosterIdAthletesGet(rosterId, offSet, pageSize, isArchived, searchContent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAthleteRostersApi.adminRostersRosterIdAthletesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add an athlete to the roster
         * @param {string} rosterId 
         * @param {AddAthleteToRosterRequest} addAthleteToRosterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRostersRosterIdAthletesPost(rosterId: string, addAthleteToRosterRequest: AddAthleteToRosterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRostersRosterIdAthletesPost(rosterId, addAthleteToRosterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAthleteRostersApi.adminRostersRosterIdAthletesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminAthleteRostersApi - factory interface
 */
export const AdminAthleteRostersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAthleteRostersApiFp(configuration)
    return {
        /**
         * 
         * @summary Approves the athlete under the roster
         * @param {AdminAthleteRostersApiAdminRostersRosterIdAthletesAthleteIdApprovePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdAthletesAthleteIdApprovePatch(requestParameters: AdminAthleteRostersApiAdminRostersRosterIdAthletesAthleteIdApprovePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminRostersRosterIdAthletesAthleteIdApprovePatch(requestParameters.rosterId, requestParameters.athleteId, requestParameters.approveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archives the athlete under the roster
         * @param {AdminAthleteRostersApiAdminRostersRosterIdAthletesAthleteIdArchivePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdAthletesAthleteIdArchivePatch(requestParameters: AdminAthleteRostersApiAdminRostersRosterIdAthletesAthleteIdArchivePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminRostersRosterIdAthletesAthleteIdArchivePatch(requestParameters.rosterId, requestParameters.athleteId, requestParameters.archiveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the athlete under the roster
         * @param {AdminAthleteRostersApiAdminRostersRosterIdAthletesAthleteIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdAthletesAthleteIdPatch(requestParameters: AdminAthleteRostersApiAdminRostersRosterIdAthletesAthleteIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminRostersRosterIdAthletesAthleteIdPatch(requestParameters.rosterId, requestParameters.athleteId, requestParameters.updateAthleteRosterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Getting the athletes under the roster
         * @param {AdminAthleteRostersApiAdminRostersRosterIdAthletesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdAthletesGet(requestParameters: AdminAthleteRostersApiAdminRostersRosterIdAthletesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminAthleteRosterResponse> {
            return localVarFp.adminRostersRosterIdAthletesGet(requestParameters.rosterId, requestParameters.offSet, requestParameters.pageSize, requestParameters.isArchived, requestParameters.searchContent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add an athlete to the roster
         * @param {AdminAthleteRostersApiAdminRostersRosterIdAthletesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdAthletesPost(requestParameters: AdminAthleteRostersApiAdminRostersRosterIdAthletesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminRostersRosterIdAthletesPost(requestParameters.rosterId, requestParameters.addAthleteToRosterRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminRostersRosterIdAthletesAthleteIdApprovePatch operation in AdminAthleteRostersApi.
 */
export interface AdminAthleteRostersApiAdminRostersRosterIdAthletesAthleteIdApprovePatchRequest {
    /**
     * 
     */
    readonly rosterId: string

    /**
     * 
     */
    readonly athleteId: string

    /**
     * 
     */
    readonly approveRequest: ApproveRequest
}

/**
 * Request parameters for adminRostersRosterIdAthletesAthleteIdArchivePatch operation in AdminAthleteRostersApi.
 */
export interface AdminAthleteRostersApiAdminRostersRosterIdAthletesAthleteIdArchivePatchRequest {
    /**
     * 
     */
    readonly rosterId: string

    /**
     * 
     */
    readonly athleteId: string

    /**
     * 
     */
    readonly archiveRequest: ArchiveRequest
}

/**
 * Request parameters for adminRostersRosterIdAthletesAthleteIdPatch operation in AdminAthleteRostersApi.
 */
export interface AdminAthleteRostersApiAdminRostersRosterIdAthletesAthleteIdPatchRequest {
    /**
     * 
     */
    readonly rosterId: string

    /**
     * 
     */
    readonly athleteId: string

    /**
     * 
     */
    readonly updateAthleteRosterRequest: UpdateAthleteRosterRequest
}

/**
 * Request parameters for adminRostersRosterIdAthletesGet operation in AdminAthleteRostersApi.
 */
export interface AdminAthleteRostersApiAdminRostersRosterIdAthletesGetRequest {
    /**
     * 
     */
    readonly rosterId: string

    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number

    /**
     * 
     */
    readonly isArchived?: boolean

    /**
     * 
     */
    readonly searchContent?: string
}

/**
 * Request parameters for adminRostersRosterIdAthletesPost operation in AdminAthleteRostersApi.
 */
export interface AdminAthleteRostersApiAdminRostersRosterIdAthletesPostRequest {
    /**
     * 
     */
    readonly rosterId: string

    /**
     * 
     */
    readonly addAthleteToRosterRequest: AddAthleteToRosterRequest
}

/**
 * AdminAthleteRostersApi - object-oriented interface
 */
export class AdminAthleteRostersApi extends BaseAPI {
    /**
     * 
     * @summary Approves the athlete under the roster
     * @param {AdminAthleteRostersApiAdminRostersRosterIdAthletesAthleteIdApprovePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminRostersRosterIdAthletesAthleteIdApprovePatch(requestParameters: AdminAthleteRostersApiAdminRostersRosterIdAthletesAthleteIdApprovePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminAthleteRostersApiFp(this.configuration).adminRostersRosterIdAthletesAthleteIdApprovePatch(requestParameters.rosterId, requestParameters.athleteId, requestParameters.approveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archives the athlete under the roster
     * @param {AdminAthleteRostersApiAdminRostersRosterIdAthletesAthleteIdArchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminRostersRosterIdAthletesAthleteIdArchivePatch(requestParameters: AdminAthleteRostersApiAdminRostersRosterIdAthletesAthleteIdArchivePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminAthleteRostersApiFp(this.configuration).adminRostersRosterIdAthletesAthleteIdArchivePatch(requestParameters.rosterId, requestParameters.athleteId, requestParameters.archiveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the athlete under the roster
     * @param {AdminAthleteRostersApiAdminRostersRosterIdAthletesAthleteIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminRostersRosterIdAthletesAthleteIdPatch(requestParameters: AdminAthleteRostersApiAdminRostersRosterIdAthletesAthleteIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminAthleteRostersApiFp(this.configuration).adminRostersRosterIdAthletesAthleteIdPatch(requestParameters.rosterId, requestParameters.athleteId, requestParameters.updateAthleteRosterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Getting the athletes under the roster
     * @param {AdminAthleteRostersApiAdminRostersRosterIdAthletesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminRostersRosterIdAthletesGet(requestParameters: AdminAthleteRostersApiAdminRostersRosterIdAthletesGetRequest, options?: RawAxiosRequestConfig) {
        return AdminAthleteRostersApiFp(this.configuration).adminRostersRosterIdAthletesGet(requestParameters.rosterId, requestParameters.offSet, requestParameters.pageSize, requestParameters.isArchived, requestParameters.searchContent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add an athlete to the roster
     * @param {AdminAthleteRostersApiAdminRostersRosterIdAthletesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminRostersRosterIdAthletesPost(requestParameters: AdminAthleteRostersApiAdminRostersRosterIdAthletesPostRequest, options?: RawAxiosRequestConfig) {
        return AdminAthleteRostersApiFp(this.configuration).adminRostersRosterIdAthletesPost(requestParameters.rosterId, requestParameters.addAthleteToRosterRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminAthletesApi - axios parameter creator
 */
export const AdminAthletesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Archive an athlete.
         * @param {string} athleteId 
         * @param {ArchiveRequest} archiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAthletesAthleteIdArchivePatch: async (athleteId: string, archiveRequest: ArchiveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'athleteId' is not null or undefined
            assertParamExists('adminAthletesAthleteIdArchivePatch', 'athleteId', athleteId)
            // verify required parameter 'archiveRequest' is not null or undefined
            assertParamExists('adminAthletesAthleteIdArchivePatch', 'archiveRequest', archiveRequest)
            const localVarPath = `/admin/athletes/{athleteId}/archive`
                .replace('{athleteId}', encodeURIComponent(String(athleteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(archiveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an athlete.
         * @param {string} athleteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAthletesAthleteIdGet: async (athleteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'athleteId' is not null or undefined
            assertParamExists('adminAthletesAthleteIdGet', 'athleteId', athleteId)
            const localVarPath = `/admin/athletes/{athleteId}`
                .replace('{athleteId}', encodeURIComponent(String(athleteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an athlete.
         * @param {string} athleteId 
         * @param {UpdateAthleteRequestDto} updateAthleteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAthletesAthleteIdPut: async (athleteId: string, updateAthleteRequestDto: UpdateAthleteRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'athleteId' is not null or undefined
            assertParamExists('adminAthletesAthleteIdPut', 'athleteId', athleteId)
            // verify required parameter 'updateAthleteRequestDto' is not null or undefined
            assertParamExists('adminAthletesAthleteIdPut', 'updateAthleteRequestDto', updateAthleteRequestDto)
            const localVarPath = `/admin/athletes/{athleteId}`
                .replace('{athleteId}', encodeURIComponent(String(athleteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAthleteRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [isArchived] 
         * @param {Array<string>} [nationality] 
         * @param {Array<string>} [sportSlug] 
         * @param {SortAthleteOn} [sortAthleteOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAthletesGet: async (searchTerm?: string, isArchived?: boolean, nationality?: Array<string>, sportSlug?: Array<string>, sortAthleteOn?: SortAthleteOn, sortDirection?: SortDirection, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/athletes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['IsArchived'] = isArchived;
            }

            if (nationality) {
                localVarQueryParameter['Nationality'] = nationality;
            }

            if (sportSlug) {
                localVarQueryParameter['SportSlug'] = sportSlug;
            }

            if (sortAthleteOn !== undefined) {
                localVarQueryParameter['SortAthleteOn'] = sortAthleteOn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an athlete.
         * @param {CreateAthleteRequest} createAthleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAthletesPost: async (createAthleteRequest: CreateAthleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAthleteRequest' is not null or undefined
            assertParamExists('adminAthletesPost', 'createAthleteRequest', createAthleteRequest)
            const localVarPath = `/admin/athletes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAthleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAthletesApi - functional programming interface
 */
export const AdminAthletesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAthletesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Archive an athlete.
         * @param {string} athleteId 
         * @param {ArchiveRequest} archiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAthletesAthleteIdArchivePatch(athleteId: string, archiveRequest: ArchiveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAthletesAthleteIdArchivePatch(athleteId, archiveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAthletesApi.adminAthletesAthleteIdArchivePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get an athlete.
         * @param {string} athleteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAthletesAthleteIdGet(athleteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAthleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAthletesAthleteIdGet(athleteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAthletesApi.adminAthletesAthleteIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an athlete.
         * @param {string} athleteId 
         * @param {UpdateAthleteRequestDto} updateAthleteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAthletesAthleteIdPut(athleteId: string, updateAthleteRequestDto: UpdateAthleteRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAthletesAthleteIdPut(athleteId, updateAthleteRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAthletesApi.adminAthletesAthleteIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [isArchived] 
         * @param {Array<string>} [nationality] 
         * @param {Array<string>} [sportSlug] 
         * @param {SortAthleteOn} [sortAthleteOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAthletesGet(searchTerm?: string, isArchived?: boolean, nationality?: Array<string>, sportSlug?: Array<string>, sortAthleteOn?: SortAthleteOn, sortDirection?: SortDirection, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminAthleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAthletesGet(searchTerm, isArchived, nationality, sportSlug, sortAthleteOn, sortDirection, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAthletesApi.adminAthletesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an athlete.
         * @param {CreateAthleteRequest} createAthleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAthletesPost(createAthleteRequest: CreateAthleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAthletesPost(createAthleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAthletesApi.adminAthletesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminAthletesApi - factory interface
 */
export const AdminAthletesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAthletesApiFp(configuration)
    return {
        /**
         * 
         * @summary Archive an athlete.
         * @param {AdminAthletesApiAdminAthletesAthleteIdArchivePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAthletesAthleteIdArchivePatch(requestParameters: AdminAthletesApiAdminAthletesAthleteIdArchivePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminAthletesAthleteIdArchivePatch(requestParameters.athleteId, requestParameters.archiveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an athlete.
         * @param {AdminAthletesApiAdminAthletesAthleteIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAthletesAthleteIdGet(requestParameters: AdminAthletesApiAdminAthletesAthleteIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminAthleteResponse> {
            return localVarFp.adminAthletesAthleteIdGet(requestParameters.athleteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an athlete.
         * @param {AdminAthletesApiAdminAthletesAthleteIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAthletesAthleteIdPut(requestParameters: AdminAthletesApiAdminAthletesAthleteIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminAthletesAthleteIdPut(requestParameters.athleteId, requestParameters.updateAthleteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminAthletesApiAdminAthletesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAthletesGet(requestParameters: AdminAthletesApiAdminAthletesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminAthleteResponse> {
            return localVarFp.adminAthletesGet(requestParameters.searchTerm, requestParameters.isArchived, requestParameters.nationality, requestParameters.sportSlug, requestParameters.sortAthleteOn, requestParameters.sortDirection, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an athlete.
         * @param {AdminAthletesApiAdminAthletesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAthletesPost(requestParameters: AdminAthletesApiAdminAthletesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminAthletesPost(requestParameters.createAthleteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminAthletesAthleteIdArchivePatch operation in AdminAthletesApi.
 */
export interface AdminAthletesApiAdminAthletesAthleteIdArchivePatchRequest {
    readonly athleteId: string

    readonly archiveRequest: ArchiveRequest
}

/**
 * Request parameters for adminAthletesAthleteIdGet operation in AdminAthletesApi.
 */
export interface AdminAthletesApiAdminAthletesAthleteIdGetRequest {
    readonly athleteId: string
}

/**
 * Request parameters for adminAthletesAthleteIdPut operation in AdminAthletesApi.
 */
export interface AdminAthletesApiAdminAthletesAthleteIdPutRequest {
    readonly athleteId: string

    readonly updateAthleteRequestDto: UpdateAthleteRequestDto
}

/**
 * Request parameters for adminAthletesGet operation in AdminAthletesApi.
 */
export interface AdminAthletesApiAdminAthletesGetRequest {
    readonly searchTerm?: string

    readonly isArchived?: boolean

    readonly nationality?: Array<string>

    readonly sportSlug?: Array<string>

    readonly sortAthleteOn?: SortAthleteOn

    readonly sortDirection?: SortDirection

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminAthletesPost operation in AdminAthletesApi.
 */
export interface AdminAthletesApiAdminAthletesPostRequest {
    readonly createAthleteRequest: CreateAthleteRequest
}

/**
 * AdminAthletesApi - object-oriented interface
 */
export class AdminAthletesApi extends BaseAPI {
    /**
     * 
     * @summary Archive an athlete.
     * @param {AdminAthletesApiAdminAthletesAthleteIdArchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminAthletesAthleteIdArchivePatch(requestParameters: AdminAthletesApiAdminAthletesAthleteIdArchivePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminAthletesApiFp(this.configuration).adminAthletesAthleteIdArchivePatch(requestParameters.athleteId, requestParameters.archiveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an athlete.
     * @param {AdminAthletesApiAdminAthletesAthleteIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminAthletesAthleteIdGet(requestParameters: AdminAthletesApiAdminAthletesAthleteIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminAthletesApiFp(this.configuration).adminAthletesAthleteIdGet(requestParameters.athleteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an athlete.
     * @param {AdminAthletesApiAdminAthletesAthleteIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminAthletesAthleteIdPut(requestParameters: AdminAthletesApiAdminAthletesAthleteIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminAthletesApiFp(this.configuration).adminAthletesAthleteIdPut(requestParameters.athleteId, requestParameters.updateAthleteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminAthletesApiAdminAthletesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminAthletesGet(requestParameters: AdminAthletesApiAdminAthletesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminAthletesApiFp(this.configuration).adminAthletesGet(requestParameters.searchTerm, requestParameters.isArchived, requestParameters.nationality, requestParameters.sportSlug, requestParameters.sortAthleteOn, requestParameters.sortDirection, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an athlete.
     * @param {AdminAthletesApiAdminAthletesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminAthletesPost(requestParameters: AdminAthletesApiAdminAthletesPostRequest, options?: RawAxiosRequestConfig) {
        return AdminAthletesApiFp(this.configuration).adminAthletesPost(requestParameters.createAthleteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminCountriesApi - axios parameter creator
 */
export const AdminCountriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} countryCodeOrId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCountriesCountryCodeOrIdGet: async (countryCodeOrId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCodeOrId' is not null or undefined
            assertParamExists('adminCountriesCountryCodeOrIdGet', 'countryCodeOrId', countryCodeOrId)
            const localVarPath = `/admin/countries/{countryCodeOrId}`
                .replace('{countryCodeOrId}', encodeURIComponent(String(countryCodeOrId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary End point to get all the countries in our db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCountriesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCountriesApi - functional programming interface
 */
export const AdminCountriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCountriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} countryCodeOrId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCountriesCountryCodeOrIdGet(countryCodeOrId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCountriesCountryCodeOrIdGet(countryCodeOrId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCountriesApi.adminCountriesCountryCodeOrIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary End point to get all the countries in our db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCountriesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CountryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCountriesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCountriesApi.adminCountriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCountriesApi - factory interface
 */
export const AdminCountriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCountriesApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminCountriesApiAdminCountriesCountryCodeOrIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCountriesCountryCodeOrIdGet(requestParameters: AdminCountriesApiAdminCountriesCountryCodeOrIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CountryDto> {
            return localVarFp.adminCountriesCountryCodeOrIdGet(requestParameters.countryCodeOrId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary End point to get all the countries in our db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCountriesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<CountryDto>> {
            return localVarFp.adminCountriesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminCountriesCountryCodeOrIdGet operation in AdminCountriesApi.
 */
export interface AdminCountriesApiAdminCountriesCountryCodeOrIdGetRequest {
    readonly countryCodeOrId: string
}

/**
 * AdminCountriesApi - object-oriented interface
 */
export class AdminCountriesApi extends BaseAPI {
    /**
     * 
     * @param {AdminCountriesApiAdminCountriesCountryCodeOrIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCountriesCountryCodeOrIdGet(requestParameters: AdminCountriesApiAdminCountriesCountryCodeOrIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminCountriesApiFp(this.configuration).adminCountriesCountryCodeOrIdGet(requestParameters.countryCodeOrId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary End point to get all the countries in our db
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCountriesGet(options?: RawAxiosRequestConfig) {
        return AdminCountriesApiFp(this.configuration).adminCountriesGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminFixturesApi - axios parameter creator
 */
export const AdminFixturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a fixture by its ID.
         * @param {string} fixtureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFixturesFixtureIdGet: async (fixtureId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fixtureId' is not null or undefined
            assertParamExists('adminFixturesFixtureIdGet', 'fixtureId', fixtureId)
            const localVarPath = `/admin/fixtures/{fixtureId}`
                .replace('{fixtureId}', encodeURIComponent(String(fixtureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a manually managed fixture. Fails if fixture is externally linked (has provider records).
         * @param {string} fixtureId 
         * @param {UpdateFixtureRequest} updateFixtureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFixturesFixtureIdPut: async (fixtureId: string, updateFixtureRequest: UpdateFixtureRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fixtureId' is not null or undefined
            assertParamExists('adminFixturesFixtureIdPut', 'fixtureId', fixtureId)
            // verify required parameter 'updateFixtureRequest' is not null or undefined
            assertParamExists('adminFixturesFixtureIdPut', 'updateFixtureRequest', updateFixtureRequest)
            const localVarPath = `/admin/fixtures/{fixtureId}`
                .replace('{fixtureId}', encodeURIComponent(String(fixtureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFixtureRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get lineup for a given team and fixture.
         * @param {string} fixtureId 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFixturesFixtureIdTeamsTeamIdLineupGet: async (fixtureId: string, teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fixtureId' is not null or undefined
            assertParamExists('adminFixturesFixtureIdTeamsTeamIdLineupGet', 'fixtureId', fixtureId)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('adminFixturesFixtureIdTeamsTeamIdLineupGet', 'teamId', teamId)
            const localVarPath = `/admin/fixtures/{fixtureId}/teams/{teamId}/lineup`
                .replace('{fixtureId}', encodeURIComponent(String(fixtureId)))
                .replace('{teamId}', encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [admin] Get roster by fixture and team.
         * @param {string} fixtureId 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFixturesFixtureIdTeamsTeamIdRosterGet: async (fixtureId: string, teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fixtureId' is not null or undefined
            assertParamExists('adminFixturesFixtureIdTeamsTeamIdRosterGet', 'fixtureId', fixtureId)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('adminFixturesFixtureIdTeamsTeamIdRosterGet', 'teamId', teamId)
            const localVarPath = `/admin/fixtures/{fixtureId}/teams/{teamId}/roster`
                .replace('{fixtureId}', encodeURIComponent(String(fixtureId)))
                .replace('{teamId}', encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get paginated list of fixtures.
         * @param {string} [searchTerm] 
         * @param {Array<string>} [teamIds] 
         * @param {Array<string>} [sportIds] 
         * @param {SortFixtureOn} [sortFixtureOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {Date} [startDateFrom] 
         * @param {Date} [startDateTo] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFixturesGet: async (searchTerm?: string, teamIds?: Array<string>, sportIds?: Array<string>, sortFixtureOn?: SortFixtureOn, sortDirection?: SortDirection, startDateFrom?: Date, startDateTo?: Date, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/fixtures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (teamIds) {
                localVarQueryParameter['TeamIds'] = teamIds;
            }

            if (sportIds) {
                localVarQueryParameter['SportIds'] = sportIds;
            }

            if (sortFixtureOn !== undefined) {
                localVarQueryParameter['SortFixtureOn'] = sortFixtureOn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (startDateFrom !== undefined) {
                localVarQueryParameter['StartDateFrom'] = (startDateFrom as any instanceof Date) ?
                    (startDateFrom as any).toISOString() :
                    startDateFrom;
            }

            if (startDateTo !== undefined) {
                localVarQueryParameter['StartDateTo'] = (startDateTo as any instanceof Date) ?
                    (startDateTo as any).toISOString() :
                    startDateTo;
            }

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Manually Create the fixture.
         * @param {CreateManualFixtureRequest} createManualFixtureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFixturesManualPost: async (createManualFixtureRequest: CreateManualFixtureRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManualFixtureRequest' is not null or undefined
            assertParamExists('adminFixturesManualPost', 'createManualFixtureRequest', createManualFixtureRequest)
            const localVarPath = `/admin/fixtures/manual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManualFixtureRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<CreateOrGetFixtureRequestDto>} createOrGetFixtureRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFixturesMultiplePost: async (createOrGetFixtureRequestDto: Array<CreateOrGetFixtureRequestDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrGetFixtureRequestDto' is not null or undefined
            assertParamExists('adminFixturesMultiplePost', 'createOrGetFixtureRequestDto', createOrGetFixtureRequestDto)
            const localVarPath = `/admin/fixtures/multiple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrGetFixtureRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFixturesApi - functional programming interface
 */
export const AdminFixturesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminFixturesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a fixture by its ID.
         * @param {string} fixtureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFixturesFixtureIdGet(fixtureId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFixtureResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFixturesFixtureIdGet(fixtureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFixturesApi.adminFixturesFixtureIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a manually managed fixture. Fails if fixture is externally linked (has provider records).
         * @param {string} fixtureId 
         * @param {UpdateFixtureRequest} updateFixtureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFixturesFixtureIdPut(fixtureId: string, updateFixtureRequest: UpdateFixtureRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFixturesFixtureIdPut(fixtureId, updateFixtureRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFixturesApi.adminFixturesFixtureIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get lineup for a given team and fixture.
         * @param {string} fixtureId 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFixturesFixtureIdTeamsTeamIdLineupGet(fixtureId: string, teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFixturesFixtureIdTeamsTeamIdLineupGet(fixtureId, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFixturesApi.adminFixturesFixtureIdTeamsTeamIdLineupGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [admin] Get roster by fixture and team.
         * @param {string} fixtureId 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFixturesFixtureIdTeamsTeamIdRosterGet(fixtureId: string, teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RosterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFixturesFixtureIdTeamsTeamIdRosterGet(fixtureId, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFixturesApi.adminFixturesFixtureIdTeamsTeamIdRosterGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get paginated list of fixtures.
         * @param {string} [searchTerm] 
         * @param {Array<string>} [teamIds] 
         * @param {Array<string>} [sportIds] 
         * @param {SortFixtureOn} [sortFixtureOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {Date} [startDateFrom] 
         * @param {Date} [startDateTo] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFixturesGet(searchTerm?: string, teamIds?: Array<string>, sportIds?: Array<string>, sortFixtureOn?: SortFixtureOn, sortDirection?: SortDirection, startDateFrom?: Date, startDateTo?: Date, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminFixtureResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFixturesGet(searchTerm, teamIds, sportIds, sortFixtureOn, sortDirection, startDateFrom, startDateTo, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFixturesApi.adminFixturesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Manually Create the fixture.
         * @param {CreateManualFixtureRequest} createManualFixtureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFixturesManualPost(createManualFixtureRequest: CreateManualFixtureRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFixturesManualPost(createManualFixtureRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFixturesApi.adminFixturesManualPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<CreateOrGetFixtureRequestDto>} createOrGetFixtureRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFixturesMultiplePost(createOrGetFixtureRequestDto: Array<CreateOrGetFixtureRequestDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FixtureAggregateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFixturesMultiplePost(createOrGetFixtureRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFixturesApi.adminFixturesMultiplePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminFixturesApi - factory interface
 */
export const AdminFixturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminFixturesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a fixture by its ID.
         * @param {AdminFixturesApiAdminFixturesFixtureIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFixturesFixtureIdGet(requestParameters: AdminFixturesApiAdminFixturesFixtureIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminFixtureResponse> {
            return localVarFp.adminFixturesFixtureIdGet(requestParameters.fixtureId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a manually managed fixture. Fails if fixture is externally linked (has provider records).
         * @param {AdminFixturesApiAdminFixturesFixtureIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFixturesFixtureIdPut(requestParameters: AdminFixturesApiAdminFixturesFixtureIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminFixturesFixtureIdPut(requestParameters.fixtureId, requestParameters.updateFixtureRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get lineup for a given team and fixture.
         * @param {AdminFixturesApiAdminFixturesFixtureIdTeamsTeamIdLineupGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFixturesFixtureIdTeamsTeamIdLineupGet(requestParameters: AdminFixturesApiAdminFixturesFixtureIdTeamsTeamIdLineupGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<LineupDto> {
            return localVarFp.adminFixturesFixtureIdTeamsTeamIdLineupGet(requestParameters.fixtureId, requestParameters.teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [admin] Get roster by fixture and team.
         * @param {AdminFixturesApiAdminFixturesFixtureIdTeamsTeamIdRosterGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFixturesFixtureIdTeamsTeamIdRosterGet(requestParameters: AdminFixturesApiAdminFixturesFixtureIdTeamsTeamIdRosterGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RosterDto> {
            return localVarFp.adminFixturesFixtureIdTeamsTeamIdRosterGet(requestParameters.fixtureId, requestParameters.teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get paginated list of fixtures.
         * @param {AdminFixturesApiAdminFixturesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFixturesGet(requestParameters: AdminFixturesApiAdminFixturesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminFixtureResponse> {
            return localVarFp.adminFixturesGet(requestParameters.searchTerm, requestParameters.teamIds, requestParameters.sportIds, requestParameters.sortFixtureOn, requestParameters.sortDirection, requestParameters.startDateFrom, requestParameters.startDateTo, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Manually Create the fixture.
         * @param {AdminFixturesApiAdminFixturesManualPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFixturesManualPost(requestParameters: AdminFixturesApiAdminFixturesManualPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminFixturesManualPost(requestParameters.createManualFixtureRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminFixturesApiAdminFixturesMultiplePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFixturesMultiplePost(requestParameters: AdminFixturesApiAdminFixturesMultiplePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<FixtureAggregateDto>> {
            return localVarFp.adminFixturesMultiplePost(requestParameters.createOrGetFixtureRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminFixturesFixtureIdGet operation in AdminFixturesApi.
 */
export interface AdminFixturesApiAdminFixturesFixtureIdGetRequest {
    readonly fixtureId: string
}

/**
 * Request parameters for adminFixturesFixtureIdPut operation in AdminFixturesApi.
 */
export interface AdminFixturesApiAdminFixturesFixtureIdPutRequest {
    readonly fixtureId: string

    readonly updateFixtureRequest: UpdateFixtureRequest
}

/**
 * Request parameters for adminFixturesFixtureIdTeamsTeamIdLineupGet operation in AdminFixturesApi.
 */
export interface AdminFixturesApiAdminFixturesFixtureIdTeamsTeamIdLineupGetRequest {
    /**
     * 
     */
    readonly fixtureId: string

    /**
     * 
     */
    readonly teamId: string
}

/**
 * Request parameters for adminFixturesFixtureIdTeamsTeamIdRosterGet operation in AdminFixturesApi.
 */
export interface AdminFixturesApiAdminFixturesFixtureIdTeamsTeamIdRosterGetRequest {
    /**
     * 
     */
    readonly fixtureId: string

    /**
     * 
     */
    readonly teamId: string
}

/**
 * Request parameters for adminFixturesGet operation in AdminFixturesApi.
 */
export interface AdminFixturesApiAdminFixturesGetRequest {
    readonly searchTerm?: string

    readonly teamIds?: Array<string>

    readonly sportIds?: Array<string>

    readonly sortFixtureOn?: SortFixtureOn

    readonly sortDirection?: SortDirection

    readonly startDateFrom?: Date

    readonly startDateTo?: Date

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminFixturesManualPost operation in AdminFixturesApi.
 */
export interface AdminFixturesApiAdminFixturesManualPostRequest {
    readonly createManualFixtureRequest: CreateManualFixtureRequest
}

/**
 * Request parameters for adminFixturesMultiplePost operation in AdminFixturesApi.
 */
export interface AdminFixturesApiAdminFixturesMultiplePostRequest {
    readonly createOrGetFixtureRequestDto: Array<CreateOrGetFixtureRequestDto>
}

/**
 * AdminFixturesApi - object-oriented interface
 */
export class AdminFixturesApi extends BaseAPI {
    /**
     * 
     * @summary Get a fixture by its ID.
     * @param {AdminFixturesApiAdminFixturesFixtureIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminFixturesFixtureIdGet(requestParameters: AdminFixturesApiAdminFixturesFixtureIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminFixturesApiFp(this.configuration).adminFixturesFixtureIdGet(requestParameters.fixtureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a manually managed fixture. Fails if fixture is externally linked (has provider records).
     * @param {AdminFixturesApiAdminFixturesFixtureIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminFixturesFixtureIdPut(requestParameters: AdminFixturesApiAdminFixturesFixtureIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminFixturesApiFp(this.configuration).adminFixturesFixtureIdPut(requestParameters.fixtureId, requestParameters.updateFixtureRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get lineup for a given team and fixture.
     * @param {AdminFixturesApiAdminFixturesFixtureIdTeamsTeamIdLineupGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminFixturesFixtureIdTeamsTeamIdLineupGet(requestParameters: AdminFixturesApiAdminFixturesFixtureIdTeamsTeamIdLineupGetRequest, options?: RawAxiosRequestConfig) {
        return AdminFixturesApiFp(this.configuration).adminFixturesFixtureIdTeamsTeamIdLineupGet(requestParameters.fixtureId, requestParameters.teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [admin] Get roster by fixture and team.
     * @param {AdminFixturesApiAdminFixturesFixtureIdTeamsTeamIdRosterGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminFixturesFixtureIdTeamsTeamIdRosterGet(requestParameters: AdminFixturesApiAdminFixturesFixtureIdTeamsTeamIdRosterGetRequest, options?: RawAxiosRequestConfig) {
        return AdminFixturesApiFp(this.configuration).adminFixturesFixtureIdTeamsTeamIdRosterGet(requestParameters.fixtureId, requestParameters.teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get paginated list of fixtures.
     * @param {AdminFixturesApiAdminFixturesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminFixturesGet(requestParameters: AdminFixturesApiAdminFixturesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminFixturesApiFp(this.configuration).adminFixturesGet(requestParameters.searchTerm, requestParameters.teamIds, requestParameters.sportIds, requestParameters.sortFixtureOn, requestParameters.sortDirection, requestParameters.startDateFrom, requestParameters.startDateTo, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Manually Create the fixture.
     * @param {AdminFixturesApiAdminFixturesManualPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminFixturesManualPost(requestParameters: AdminFixturesApiAdminFixturesManualPostRequest, options?: RawAxiosRequestConfig) {
        return AdminFixturesApiFp(this.configuration).adminFixturesManualPost(requestParameters.createManualFixtureRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminFixturesApiAdminFixturesMultiplePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminFixturesMultiplePost(requestParameters: AdminFixturesApiAdminFixturesMultiplePostRequest, options?: RawAxiosRequestConfig) {
        return AdminFixturesApiFp(this.configuration).adminFixturesMultiplePost(requestParameters.createOrGetFixtureRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminLeaguesApi - axios parameter creator
 */
export const AdminLeaguesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get paginated list of leagues.
         * @param {string} [searchTerm] 
         * @param {Array<string>} [countryIds] 
         * @param {boolean} [isArchived] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLeaguesGet: async (searchTerm?: string, countryIds?: Array<string>, isArchived?: boolean, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/leagues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (countryIds) {
                localVarQueryParameter['CountryIds'] = countryIds;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['IsArchived'] = isArchived;
            }

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive a league.
         * @param {string} leagueId 
         * @param {ArchiveRequest} archiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLeaguesLeagueIdArchivePatch: async (leagueId: string, archiveRequest: ArchiveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leagueId' is not null or undefined
            assertParamExists('adminLeaguesLeagueIdArchivePatch', 'leagueId', leagueId)
            // verify required parameter 'archiveRequest' is not null or undefined
            assertParamExists('adminLeaguesLeagueIdArchivePatch', 'archiveRequest', archiveRequest)
            const localVarPath = `/admin/leagues/{leagueId}/archive`
                .replace('{leagueId}', encodeURIComponent(String(leagueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(archiveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a league by its id.
         * @param {string} leagueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLeaguesLeagueIdGet: async (leagueId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leagueId' is not null or undefined
            assertParamExists('adminLeaguesLeagueIdGet', 'leagueId', leagueId)
            const localVarPath = `/admin/leagues/{leagueId}`
                .replace('{leagueId}', encodeURIComponent(String(leagueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [admin] Update a league.
         * @param {string} leagueId 
         * @param {UpdateLeagueRequest} updateLeagueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLeaguesLeagueIdPut: async (leagueId: string, updateLeagueRequest: UpdateLeagueRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leagueId' is not null or undefined
            assertParamExists('adminLeaguesLeagueIdPut', 'leagueId', leagueId)
            // verify required parameter 'updateLeagueRequest' is not null or undefined
            assertParamExists('adminLeaguesLeagueIdPut', 'updateLeagueRequest', updateLeagueRequest)
            const localVarPath = `/admin/leagues/{leagueId}`
                .replace('{leagueId}', encodeURIComponent(String(leagueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLeagueRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [admin] Create a league manually
         * @param {CreateLeagueRequest} createLeagueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLeaguesPost: async (createLeagueRequest: CreateLeagueRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLeagueRequest' is not null or undefined
            assertParamExists('adminLeaguesPost', 'createLeagueRequest', createLeagueRequest)
            const localVarPath = `/admin/leagues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLeagueRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all leagues that are connected to a team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLeaguesTeamTeamIdGet: async (teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('adminLeaguesTeamTeamIdGet', 'teamId', teamId)
            const localVarPath = `/admin/leagues/team/{teamId}`
                .replace('{teamId}', encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminLeaguesApi - functional programming interface
 */
export const AdminLeaguesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminLeaguesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get paginated list of leagues.
         * @param {string} [searchTerm] 
         * @param {Array<string>} [countryIds] 
         * @param {boolean} [isArchived] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLeaguesGet(searchTerm?: string, countryIds?: Array<string>, isArchived?: boolean, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfLeagueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLeaguesGet(searchTerm, countryIds, isArchived, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLeaguesApi.adminLeaguesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archive a league.
         * @param {string} leagueId 
         * @param {ArchiveRequest} archiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLeaguesLeagueIdArchivePatch(leagueId: string, archiveRequest: ArchiveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLeaguesLeagueIdArchivePatch(leagueId, archiveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLeaguesApi.adminLeaguesLeagueIdArchivePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a league by its id.
         * @param {string} leagueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLeaguesLeagueIdGet(leagueId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeagueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLeaguesLeagueIdGet(leagueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLeaguesApi.adminLeaguesLeagueIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [admin] Update a league.
         * @param {string} leagueId 
         * @param {UpdateLeagueRequest} updateLeagueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLeaguesLeagueIdPut(leagueId: string, updateLeagueRequest: UpdateLeagueRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLeaguesLeagueIdPut(leagueId, updateLeagueRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLeaguesApi.adminLeaguesLeagueIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [admin] Create a league manually
         * @param {CreateLeagueRequest} createLeagueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLeaguesPost(createLeagueRequest: CreateLeagueRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLeaguesPost(createLeagueRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLeaguesApi.adminLeaguesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all leagues that are connected to a team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLeaguesTeamTeamIdGet(teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LeagueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLeaguesTeamTeamIdGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLeaguesApi.adminLeaguesTeamTeamIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminLeaguesApi - factory interface
 */
export const AdminLeaguesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminLeaguesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get paginated list of leagues.
         * @param {AdminLeaguesApiAdminLeaguesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLeaguesGet(requestParameters: AdminLeaguesApiAdminLeaguesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfLeagueDto> {
            return localVarFp.adminLeaguesGet(requestParameters.searchTerm, requestParameters.countryIds, requestParameters.isArchived, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive a league.
         * @param {AdminLeaguesApiAdminLeaguesLeagueIdArchivePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLeaguesLeagueIdArchivePatch(requestParameters: AdminLeaguesApiAdminLeaguesLeagueIdArchivePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminLeaguesLeagueIdArchivePatch(requestParameters.leagueId, requestParameters.archiveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a league by its id.
         * @param {AdminLeaguesApiAdminLeaguesLeagueIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLeaguesLeagueIdGet(requestParameters: AdminLeaguesApiAdminLeaguesLeagueIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<LeagueDto> {
            return localVarFp.adminLeaguesLeagueIdGet(requestParameters.leagueId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [admin] Update a league.
         * @param {AdminLeaguesApiAdminLeaguesLeagueIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLeaguesLeagueIdPut(requestParameters: AdminLeaguesApiAdminLeaguesLeagueIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminLeaguesLeagueIdPut(requestParameters.leagueId, requestParameters.updateLeagueRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [admin] Create a league manually
         * @param {AdminLeaguesApiAdminLeaguesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLeaguesPost(requestParameters: AdminLeaguesApiAdminLeaguesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminLeaguesPost(requestParameters.createLeagueRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all leagues that are connected to a team
         * @param {AdminLeaguesApiAdminLeaguesTeamTeamIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLeaguesTeamTeamIdGet(requestParameters: AdminLeaguesApiAdminLeaguesTeamTeamIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<LeagueDto>> {
            return localVarFp.adminLeaguesTeamTeamIdGet(requestParameters.teamId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminLeaguesGet operation in AdminLeaguesApi.
 */
export interface AdminLeaguesApiAdminLeaguesGetRequest {
    readonly searchTerm?: string

    readonly countryIds?: Array<string>

    readonly isArchived?: boolean

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminLeaguesLeagueIdArchivePatch operation in AdminLeaguesApi.
 */
export interface AdminLeaguesApiAdminLeaguesLeagueIdArchivePatchRequest {
    readonly leagueId: string

    readonly archiveRequest: ArchiveRequest
}

/**
 * Request parameters for adminLeaguesLeagueIdGet operation in AdminLeaguesApi.
 */
export interface AdminLeaguesApiAdminLeaguesLeagueIdGetRequest {
    readonly leagueId: string
}

/**
 * Request parameters for adminLeaguesLeagueIdPut operation in AdminLeaguesApi.
 */
export interface AdminLeaguesApiAdminLeaguesLeagueIdPutRequest {
    readonly leagueId: string

    readonly updateLeagueRequest: UpdateLeagueRequest
}

/**
 * Request parameters for adminLeaguesPost operation in AdminLeaguesApi.
 */
export interface AdminLeaguesApiAdminLeaguesPostRequest {
    readonly createLeagueRequest: CreateLeagueRequest
}

/**
 * Request parameters for adminLeaguesTeamTeamIdGet operation in AdminLeaguesApi.
 */
export interface AdminLeaguesApiAdminLeaguesTeamTeamIdGetRequest {
    readonly teamId: string
}

/**
 * AdminLeaguesApi - object-oriented interface
 */
export class AdminLeaguesApi extends BaseAPI {
    /**
     * 
     * @summary Get paginated list of leagues.
     * @param {AdminLeaguesApiAdminLeaguesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLeaguesGet(requestParameters: AdminLeaguesApiAdminLeaguesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminLeaguesApiFp(this.configuration).adminLeaguesGet(requestParameters.searchTerm, requestParameters.countryIds, requestParameters.isArchived, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive a league.
     * @param {AdminLeaguesApiAdminLeaguesLeagueIdArchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLeaguesLeagueIdArchivePatch(requestParameters: AdminLeaguesApiAdminLeaguesLeagueIdArchivePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminLeaguesApiFp(this.configuration).adminLeaguesLeagueIdArchivePatch(requestParameters.leagueId, requestParameters.archiveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a league by its id.
     * @param {AdminLeaguesApiAdminLeaguesLeagueIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLeaguesLeagueIdGet(requestParameters: AdminLeaguesApiAdminLeaguesLeagueIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminLeaguesApiFp(this.configuration).adminLeaguesLeagueIdGet(requestParameters.leagueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [admin] Update a league.
     * @param {AdminLeaguesApiAdminLeaguesLeagueIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLeaguesLeagueIdPut(requestParameters: AdminLeaguesApiAdminLeaguesLeagueIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminLeaguesApiFp(this.configuration).adminLeaguesLeagueIdPut(requestParameters.leagueId, requestParameters.updateLeagueRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [admin] Create a league manually
     * @param {AdminLeaguesApiAdminLeaguesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLeaguesPost(requestParameters: AdminLeaguesApiAdminLeaguesPostRequest, options?: RawAxiosRequestConfig) {
        return AdminLeaguesApiFp(this.configuration).adminLeaguesPost(requestParameters.createLeagueRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all leagues that are connected to a team
     * @param {AdminLeaguesApiAdminLeaguesTeamTeamIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLeaguesTeamTeamIdGet(requestParameters: AdminLeaguesApiAdminLeaguesTeamTeamIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminLeaguesApiFp(this.configuration).adminLeaguesTeamTeamIdGet(requestParameters.teamId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminLineupApi - axios parameter creator
 */
export const AdminLineupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} lineupId 
         * @param {CreateAthleteLineupRequest} createAthleteLineupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLineupsLineupIdAthletesPost: async (lineupId: string, createAthleteLineupRequest: CreateAthleteLineupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineupId' is not null or undefined
            assertParamExists('adminLineupsLineupIdAthletesPost', 'lineupId', lineupId)
            // verify required parameter 'createAthleteLineupRequest' is not null or undefined
            assertParamExists('adminLineupsLineupIdAthletesPost', 'createAthleteLineupRequest', createAthleteLineupRequest)
            const localVarPath = `/admin/lineups/{lineupId}/athletes`
                .replace('{lineupId}', encodeURIComponent(String(lineupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAthleteLineupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} lineupId 
         * @param {UpdateLineupWithAthletesRequest} updateLineupWithAthletesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLineupsLineupIdAthletesPut: async (lineupId: string, updateLineupWithAthletesRequest: UpdateLineupWithAthletesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineupId' is not null or undefined
            assertParamExists('adminLineupsLineupIdAthletesPut', 'lineupId', lineupId)
            // verify required parameter 'updateLineupWithAthletesRequest' is not null or undefined
            assertParamExists('adminLineupsLineupIdAthletesPut', 'updateLineupWithAthletesRequest', updateLineupWithAthletesRequest)
            const localVarPath = `/admin/lineups/{lineupId}/athletes`
                .replace('{lineupId}', encodeURIComponent(String(lineupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLineupWithAthletesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} fixtureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLineupsTeamsTeamIdFixturesFixtureIdGet: async (teamId: string, fixtureId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('adminLineupsTeamsTeamIdFixturesFixtureIdGet', 'teamId', teamId)
            // verify required parameter 'fixtureId' is not null or undefined
            assertParamExists('adminLineupsTeamsTeamIdFixturesFixtureIdGet', 'fixtureId', fixtureId)
            const localVarPath = `/admin/lineups/teams/{teamId}/fixtures/{fixtureId}`
                .replace('{teamId}', encodeURIComponent(String(teamId)))
                .replace('{fixtureId}', encodeURIComponent(String(fixtureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminLineupApi - functional programming interface
 */
export const AdminLineupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminLineupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} lineupId 
         * @param {CreateAthleteLineupRequest} createAthleteLineupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLineupsLineupIdAthletesPost(lineupId: string, createAthleteLineupRequest: CreateAthleteLineupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLineupsLineupIdAthletesPost(lineupId, createAthleteLineupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLineupApi.adminLineupsLineupIdAthletesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} lineupId 
         * @param {UpdateLineupWithAthletesRequest} updateLineupWithAthletesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLineupsLineupIdAthletesPut(lineupId: string, updateLineupWithAthletesRequest: UpdateLineupWithAthletesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLineupsLineupIdAthletesPut(lineupId, updateLineupWithAthletesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLineupApi.adminLineupsLineupIdAthletesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} fixtureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLineupsTeamsTeamIdFixturesFixtureIdGet(teamId: string, fixtureId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminLineupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLineupsTeamsTeamIdFixturesFixtureIdGet(teamId, fixtureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLineupApi.adminLineupsTeamsTeamIdFixturesFixtureIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminLineupApi - factory interface
 */
export const AdminLineupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminLineupApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminLineupApiAdminLineupsLineupIdAthletesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLineupsLineupIdAthletesPost(requestParameters: AdminLineupApiAdminLineupsLineupIdAthletesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminLineupsLineupIdAthletesPost(requestParameters.lineupId, requestParameters.createAthleteLineupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminLineupApiAdminLineupsLineupIdAthletesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLineupsLineupIdAthletesPut(requestParameters: AdminLineupApiAdminLineupsLineupIdAthletesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminLineupsLineupIdAthletesPut(requestParameters.lineupId, requestParameters.updateLineupWithAthletesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminLineupApiAdminLineupsTeamsTeamIdFixturesFixtureIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLineupsTeamsTeamIdFixturesFixtureIdGet(requestParameters: AdminLineupApiAdminLineupsTeamsTeamIdFixturesFixtureIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminLineupResponse> {
            return localVarFp.adminLineupsTeamsTeamIdFixturesFixtureIdGet(requestParameters.teamId, requestParameters.fixtureId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminLineupsLineupIdAthletesPost operation in AdminLineupApi.
 */
export interface AdminLineupApiAdminLineupsLineupIdAthletesPostRequest {
    readonly lineupId: string

    readonly createAthleteLineupRequest: CreateAthleteLineupRequest
}

/**
 * Request parameters for adminLineupsLineupIdAthletesPut operation in AdminLineupApi.
 */
export interface AdminLineupApiAdminLineupsLineupIdAthletesPutRequest {
    readonly lineupId: string

    readonly updateLineupWithAthletesRequest: UpdateLineupWithAthletesRequest
}

/**
 * Request parameters for adminLineupsTeamsTeamIdFixturesFixtureIdGet operation in AdminLineupApi.
 */
export interface AdminLineupApiAdminLineupsTeamsTeamIdFixturesFixtureIdGetRequest {
    readonly teamId: string

    readonly fixtureId: string
}

/**
 * AdminLineupApi - object-oriented interface
 */
export class AdminLineupApi extends BaseAPI {
    /**
     * 
     * @param {AdminLineupApiAdminLineupsLineupIdAthletesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLineupsLineupIdAthletesPost(requestParameters: AdminLineupApiAdminLineupsLineupIdAthletesPostRequest, options?: RawAxiosRequestConfig) {
        return AdminLineupApiFp(this.configuration).adminLineupsLineupIdAthletesPost(requestParameters.lineupId, requestParameters.createAthleteLineupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminLineupApiAdminLineupsLineupIdAthletesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLineupsLineupIdAthletesPut(requestParameters: AdminLineupApiAdminLineupsLineupIdAthletesPutRequest, options?: RawAxiosRequestConfig) {
        return AdminLineupApiFp(this.configuration).adminLineupsLineupIdAthletesPut(requestParameters.lineupId, requestParameters.updateLineupWithAthletesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminLineupApiAdminLineupsTeamsTeamIdFixturesFixtureIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLineupsTeamsTeamIdFixturesFixtureIdGet(requestParameters: AdminLineupApiAdminLineupsTeamsTeamIdFixturesFixtureIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminLineupApiFp(this.configuration).adminLineupsTeamsTeamIdFixturesFixtureIdGet(requestParameters.teamId, requestParameters.fixtureId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProvidersApi - axios parameter creator
 */
export const AdminProvidersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [admin] Returns a list of teams based on a given search term. Processed by external sport data provider.
         * @param {string} sportSlug The sport for which to fetch teams
         * @param {string} providerSlug The external provider that should process this request (for example: \&#39;sportmonks\&#39;)
         * @param {string} [searchTerm] The search term you want to query against.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sportSlugProvidersProviderSlugTeamsGet: async (sportSlug: string, providerSlug: string, searchTerm?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sportSlug' is not null or undefined
            assertParamExists('sportSlugProvidersProviderSlugTeamsGet', 'sportSlug', sportSlug)
            // verify required parameter 'providerSlug' is not null or undefined
            assertParamExists('sportSlugProvidersProviderSlugTeamsGet', 'providerSlug', providerSlug)
            const localVarPath = `/{sportSlug}/providers/{providerSlug}/teams`
                .replace('{sportSlug}', encodeURIComponent(String(sportSlug)))
                .replace('{providerSlug}', encodeURIComponent(String(providerSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [admin] Returns a list of fixtures for a given time period and external team id. Processed by external sport data provider.
         * @param {string} sportSlug The sport for which to fetch fixtures
         * @param {string} providerSlug The external provider that should process this request (for example: \&#39;sportmonks\&#39;)
         * @param {number} teamId The team id provided by the external provider.
         * @param {string} [startDate] The start date of the period. notation: \&#39;yyyy-MM.dd\&#39; (optional)
         * @param {string} [endDate] The end date of the period. notation: \&#39;yyyy-MM.dd\&#39; (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sportSlugProvidersProviderSlugTeamsTeamIdFixturesGet: async (sportSlug: string, providerSlug: string, teamId: number, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sportSlug' is not null or undefined
            assertParamExists('sportSlugProvidersProviderSlugTeamsTeamIdFixturesGet', 'sportSlug', sportSlug)
            // verify required parameter 'providerSlug' is not null or undefined
            assertParamExists('sportSlugProvidersProviderSlugTeamsTeamIdFixturesGet', 'providerSlug', providerSlug)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('sportSlugProvidersProviderSlugTeamsTeamIdFixturesGet', 'teamId', teamId)
            const localVarPath = `/{sportSlug}/providers/{providerSlug}/teams/{teamId}/fixtures`
                .replace('{sportSlug}', encodeURIComponent(String(sportSlug)))
                .replace('{providerSlug}', encodeURIComponent(String(providerSlug)))
                .replace('{teamId}', encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProvidersApi - functional programming interface
 */
export const AdminProvidersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProvidersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [admin] Returns a list of teams based on a given search term. Processed by external sport data provider.
         * @param {string} sportSlug The sport for which to fetch teams
         * @param {string} providerSlug The external provider that should process this request (for example: \&#39;sportmonks\&#39;)
         * @param {string} [searchTerm] The search term you want to query against.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sportSlugProvidersProviderSlugTeamsGet(sportSlug: string, providerSlug: string, searchTerm?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExternalTeamDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sportSlugProvidersProviderSlugTeamsGet(sportSlug, providerSlug, searchTerm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProvidersApi.sportSlugProvidersProviderSlugTeamsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [admin] Returns a list of fixtures for a given time period and external team id. Processed by external sport data provider.
         * @param {string} sportSlug The sport for which to fetch fixtures
         * @param {string} providerSlug The external provider that should process this request (for example: \&#39;sportmonks\&#39;)
         * @param {number} teamId The team id provided by the external provider.
         * @param {string} [startDate] The start date of the period. notation: \&#39;yyyy-MM.dd\&#39; (optional)
         * @param {string} [endDate] The end date of the period. notation: \&#39;yyyy-MM.dd\&#39; (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sportSlugProvidersProviderSlugTeamsTeamIdFixturesGet(sportSlug: string, providerSlug: string, teamId: number, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExternalFixtureDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sportSlugProvidersProviderSlugTeamsTeamIdFixturesGet(sportSlug, providerSlug, teamId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProvidersApi.sportSlugProvidersProviderSlugTeamsTeamIdFixturesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProvidersApi - factory interface
 */
export const AdminProvidersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProvidersApiFp(configuration)
    return {
        /**
         * 
         * @summary [admin] Returns a list of teams based on a given search term. Processed by external sport data provider.
         * @param {AdminProvidersApiSportSlugProvidersProviderSlugTeamsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sportSlugProvidersProviderSlugTeamsGet(requestParameters: AdminProvidersApiSportSlugProvidersProviderSlugTeamsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExternalTeamDto>> {
            return localVarFp.sportSlugProvidersProviderSlugTeamsGet(requestParameters.sportSlug, requestParameters.providerSlug, requestParameters.searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [admin] Returns a list of fixtures for a given time period and external team id. Processed by external sport data provider.
         * @param {AdminProvidersApiSportSlugProvidersProviderSlugTeamsTeamIdFixturesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sportSlugProvidersProviderSlugTeamsTeamIdFixturesGet(requestParameters: AdminProvidersApiSportSlugProvidersProviderSlugTeamsTeamIdFixturesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExternalFixtureDto>> {
            return localVarFp.sportSlugProvidersProviderSlugTeamsTeamIdFixturesGet(requestParameters.sportSlug, requestParameters.providerSlug, requestParameters.teamId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sportSlugProvidersProviderSlugTeamsGet operation in AdminProvidersApi.
 */
export interface AdminProvidersApiSportSlugProvidersProviderSlugTeamsGetRequest {
    /**
     * The sport for which to fetch teams
     */
    readonly sportSlug: string

    /**
     * The external provider that should process this request (for example: \&#39;sportmonks\&#39;)
     */
    readonly providerSlug: string

    /**
     * The search term you want to query against.
     */
    readonly searchTerm?: string
}

/**
 * Request parameters for sportSlugProvidersProviderSlugTeamsTeamIdFixturesGet operation in AdminProvidersApi.
 */
export interface AdminProvidersApiSportSlugProvidersProviderSlugTeamsTeamIdFixturesGetRequest {
    /**
     * The sport for which to fetch fixtures
     */
    readonly sportSlug: string

    /**
     * The external provider that should process this request (for example: \&#39;sportmonks\&#39;)
     */
    readonly providerSlug: string

    /**
     * The team id provided by the external provider.
     */
    readonly teamId: number

    /**
     * The start date of the period. notation: \&#39;yyyy-MM.dd\&#39; (optional)
     */
    readonly startDate?: string

    /**
     * The end date of the period. notation: \&#39;yyyy-MM.dd\&#39; (optional)
     */
    readonly endDate?: string
}

/**
 * AdminProvidersApi - object-oriented interface
 */
export class AdminProvidersApi extends BaseAPI {
    /**
     * 
     * @summary [admin] Returns a list of teams based on a given search term. Processed by external sport data provider.
     * @param {AdminProvidersApiSportSlugProvidersProviderSlugTeamsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sportSlugProvidersProviderSlugTeamsGet(requestParameters: AdminProvidersApiSportSlugProvidersProviderSlugTeamsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminProvidersApiFp(this.configuration).sportSlugProvidersProviderSlugTeamsGet(requestParameters.sportSlug, requestParameters.providerSlug, requestParameters.searchTerm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [admin] Returns a list of fixtures for a given time period and external team id. Processed by external sport data provider.
     * @param {AdminProvidersApiSportSlugProvidersProviderSlugTeamsTeamIdFixturesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sportSlugProvidersProviderSlugTeamsTeamIdFixturesGet(requestParameters: AdminProvidersApiSportSlugProvidersProviderSlugTeamsTeamIdFixturesGetRequest, options?: RawAxiosRequestConfig) {
        return AdminProvidersApiFp(this.configuration).sportSlugProvidersProviderSlugTeamsTeamIdFixturesGet(requestParameters.sportSlug, requestParameters.providerSlug, requestParameters.teamId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminRostersApi - axios parameter creator
 */
export const AdminRostersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets the rosters that has the athlete
         * @param {string} athleteId 
         * @param {string} [searchTerm] 
         * @param {boolean} [isArchived] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersAthletesAthleteIdGet: async (athleteId: string, searchTerm?: string, isArchived?: boolean, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'athleteId' is not null or undefined
            assertParamExists('adminRostersAthletesAthleteIdGet', 'athleteId', athleteId)
            const localVarPath = `/admin/rosters/athletes/{athleteId}`
                .replace('{athleteId}', encodeURIComponent(String(athleteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['isArchived'] = isArchived;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a season roster for the given team and season and populates its athletes from Sportmonks. Returns 409 Conflict if a roster already exists for that team and season.
         * @param {CreateSeasonRosterRequest} createSeasonRosterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersPost: async (createSeasonRosterRequest: CreateSeasonRosterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSeasonRosterRequest' is not null or undefined
            assertParamExists('adminRostersPost', 'createSeasonRosterRequest', createSeasonRosterRequest)
            const localVarPath = `/admin/rosters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSeasonRosterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archives a roster
         * @param {string} rosterId 
         * @param {ArchiveRequest} archiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdArchivePatch: async (rosterId: string, archiveRequest: ArchiveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rosterId' is not null or undefined
            assertParamExists('adminRostersRosterIdArchivePatch', 'rosterId', rosterId)
            // verify required parameter 'archiveRequest' is not null or undefined
            assertParamExists('adminRostersRosterIdArchivePatch', 'archiveRequest', archiveRequest)
            const localVarPath = `/admin/rosters/{rosterId}/archive`
                .replace('{rosterId}', encodeURIComponent(String(rosterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(archiveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the roster by id
         * @param {string} rosterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdGet: async (rosterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rosterId' is not null or undefined
            assertParamExists('adminRostersRosterIdGet', 'rosterId', rosterId)
            const localVarPath = `/admin/rosters/{rosterId}`
                .replace('{rosterId}', encodeURIComponent(String(rosterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Syncs the roster with sportmonks data
         * @param {string} rosterId 
         * @param {string} providerSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdProvidersProviderSlugPatch: async (rosterId: string, providerSlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rosterId' is not null or undefined
            assertParamExists('adminRostersRosterIdProvidersProviderSlugPatch', 'rosterId', rosterId)
            // verify required parameter 'providerSlug' is not null or undefined
            assertParamExists('adminRostersRosterIdProvidersProviderSlugPatch', 'providerSlug', providerSlug)
            const localVarPath = `/admin/rosters/{rosterId}/providers/{providerSlug}`
                .replace('{rosterId}', encodeURIComponent(String(rosterId)))
                .replace('{providerSlug}', encodeURIComponent(String(providerSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the rosters under the team
         * @param {string} teamId 
         * @param {string} [searchTerm] on season or league names
         * @param {boolean} [isArchived] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersTeamsTeamIdGet: async (teamId: string, searchTerm?: string, isArchived?: boolean, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('adminRostersTeamsTeamIdGet', 'teamId', teamId)
            const localVarPath = `/admin/rosters/teams/{teamId}`
                .replace('{teamId}', encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['isArchived'] = isArchived;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminRostersApi - functional programming interface
 */
export const AdminRostersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminRostersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets the rosters that has the athlete
         * @param {string} athleteId 
         * @param {string} [searchTerm] 
         * @param {boolean} [isArchived] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRostersAthletesAthleteIdGet(athleteId: string, searchTerm?: string, isArchived?: boolean, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminRosterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRostersAthletesAthleteIdGet(athleteId, searchTerm, isArchived, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRostersApi.adminRostersAthletesAthleteIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a season roster for the given team and season and populates its athletes from Sportmonks. Returns 409 Conflict if a roster already exists for that team and season.
         * @param {CreateSeasonRosterRequest} createSeasonRosterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRostersPost(createSeasonRosterRequest: CreateSeasonRosterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRostersPost(createSeasonRosterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRostersApi.adminRostersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archives a roster
         * @param {string} rosterId 
         * @param {ArchiveRequest} archiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRostersRosterIdArchivePatch(rosterId: string, archiveRequest: ArchiveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRostersRosterIdArchivePatch(rosterId, archiveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRostersApi.adminRostersRosterIdArchivePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the roster by id
         * @param {string} rosterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRostersRosterIdGet(rosterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminRosterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRostersRosterIdGet(rosterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRostersApi.adminRostersRosterIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Syncs the roster with sportmonks data
         * @param {string} rosterId 
         * @param {string} providerSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRostersRosterIdProvidersProviderSlugPatch(rosterId: string, providerSlug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRostersRosterIdProvidersProviderSlugPatch(rosterId, providerSlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRostersApi.adminRostersRosterIdProvidersProviderSlugPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the rosters under the team
         * @param {string} teamId 
         * @param {string} [searchTerm] on season or league names
         * @param {boolean} [isArchived] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRostersTeamsTeamIdGet(teamId: string, searchTerm?: string, isArchived?: boolean, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminRosterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRostersTeamsTeamIdGet(teamId, searchTerm, isArchived, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRostersApi.adminRostersTeamsTeamIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminRostersApi - factory interface
 */
export const AdminRostersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminRostersApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets the rosters that has the athlete
         * @param {AdminRostersApiAdminRostersAthletesAthleteIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersAthletesAthleteIdGet(requestParameters: AdminRostersApiAdminRostersAthletesAthleteIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminRosterResponse> {
            return localVarFp.adminRostersAthletesAthleteIdGet(requestParameters.athleteId, requestParameters.searchTerm, requestParameters.isArchived, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a season roster for the given team and season and populates its athletes from Sportmonks. Returns 409 Conflict if a roster already exists for that team and season.
         * @param {AdminRostersApiAdminRostersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersPost(requestParameters: AdminRostersApiAdminRostersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminRostersPost(requestParameters.createSeasonRosterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archives a roster
         * @param {AdminRostersApiAdminRostersRosterIdArchivePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdArchivePatch(requestParameters: AdminRostersApiAdminRostersRosterIdArchivePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminRostersRosterIdArchivePatch(requestParameters.rosterId, requestParameters.archiveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the roster by id
         * @param {AdminRostersApiAdminRostersRosterIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdGet(requestParameters: AdminRostersApiAdminRostersRosterIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminRosterResponse> {
            return localVarFp.adminRostersRosterIdGet(requestParameters.rosterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Syncs the roster with sportmonks data
         * @param {AdminRostersApiAdminRostersRosterIdProvidersProviderSlugPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersRosterIdProvidersProviderSlugPatch(requestParameters: AdminRostersApiAdminRostersRosterIdProvidersProviderSlugPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminRostersRosterIdProvidersProviderSlugPatch(requestParameters.rosterId, requestParameters.providerSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the rosters under the team
         * @param {AdminRostersApiAdminRostersTeamsTeamIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRostersTeamsTeamIdGet(requestParameters: AdminRostersApiAdminRostersTeamsTeamIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminRosterResponse> {
            return localVarFp.adminRostersTeamsTeamIdGet(requestParameters.teamId, requestParameters.searchTerm, requestParameters.isArchived, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminRostersAthletesAthleteIdGet operation in AdminRostersApi.
 */
export interface AdminRostersApiAdminRostersAthletesAthleteIdGetRequest {
    /**
     * 
     */
    readonly athleteId: string

    /**
     * 
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly isArchived?: boolean

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * Request parameters for adminRostersPost operation in AdminRostersApi.
 */
export interface AdminRostersApiAdminRostersPostRequest {
    /**
     * 
     */
    readonly createSeasonRosterRequest: CreateSeasonRosterRequest
}

/**
 * Request parameters for adminRostersRosterIdArchivePatch operation in AdminRostersApi.
 */
export interface AdminRostersApiAdminRostersRosterIdArchivePatchRequest {
    /**
     * 
     */
    readonly rosterId: string

    /**
     * 
     */
    readonly archiveRequest: ArchiveRequest
}

/**
 * Request parameters for adminRostersRosterIdGet operation in AdminRostersApi.
 */
export interface AdminRostersApiAdminRostersRosterIdGetRequest {
    /**
     * 
     */
    readonly rosterId: string
}

/**
 * Request parameters for adminRostersRosterIdProvidersProviderSlugPatch operation in AdminRostersApi.
 */
export interface AdminRostersApiAdminRostersRosterIdProvidersProviderSlugPatchRequest {
    /**
     * 
     */
    readonly rosterId: string

    readonly providerSlug: string
}

/**
 * Request parameters for adminRostersTeamsTeamIdGet operation in AdminRostersApi.
 */
export interface AdminRostersApiAdminRostersTeamsTeamIdGetRequest {
    /**
     * 
     */
    readonly teamId: string

    /**
     * on season or league names
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly isArchived?: boolean

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * AdminRostersApi - object-oriented interface
 */
export class AdminRostersApi extends BaseAPI {
    /**
     * 
     * @summary Gets the rosters that has the athlete
     * @param {AdminRostersApiAdminRostersAthletesAthleteIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminRostersAthletesAthleteIdGet(requestParameters: AdminRostersApiAdminRostersAthletesAthleteIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminRostersApiFp(this.configuration).adminRostersAthletesAthleteIdGet(requestParameters.athleteId, requestParameters.searchTerm, requestParameters.isArchived, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a season roster for the given team and season and populates its athletes from Sportmonks. Returns 409 Conflict if a roster already exists for that team and season.
     * @param {AdminRostersApiAdminRostersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminRostersPost(requestParameters: AdminRostersApiAdminRostersPostRequest, options?: RawAxiosRequestConfig) {
        return AdminRostersApiFp(this.configuration).adminRostersPost(requestParameters.createSeasonRosterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archives a roster
     * @param {AdminRostersApiAdminRostersRosterIdArchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminRostersRosterIdArchivePatch(requestParameters: AdminRostersApiAdminRostersRosterIdArchivePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminRostersApiFp(this.configuration).adminRostersRosterIdArchivePatch(requestParameters.rosterId, requestParameters.archiveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the roster by id
     * @param {AdminRostersApiAdminRostersRosterIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminRostersRosterIdGet(requestParameters: AdminRostersApiAdminRostersRosterIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminRostersApiFp(this.configuration).adminRostersRosterIdGet(requestParameters.rosterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Syncs the roster with sportmonks data
     * @param {AdminRostersApiAdminRostersRosterIdProvidersProviderSlugPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminRostersRosterIdProvidersProviderSlugPatch(requestParameters: AdminRostersApiAdminRostersRosterIdProvidersProviderSlugPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminRostersApiFp(this.configuration).adminRostersRosterIdProvidersProviderSlugPatch(requestParameters.rosterId, requestParameters.providerSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the rosters under the team
     * @param {AdminRostersApiAdminRostersTeamsTeamIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminRostersTeamsTeamIdGet(requestParameters: AdminRostersApiAdminRostersTeamsTeamIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminRostersApiFp(this.configuration).adminRostersTeamsTeamIdGet(requestParameters.teamId, requestParameters.searchTerm, requestParameters.isArchived, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminSportsApi - axios parameter creator
 */
export const AdminSportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List of all sports
         * @param {string} [searchTerm] 
         * @param {boolean} [isArchived] 
         * @param {SortSportOn} [sortSportOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSportsGet: async (searchTerm?: string, isArchived?: boolean, sortSportOn?: SortSportOn, sortDirection?: SortDirection, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/sports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['IsArchived'] = isArchived;
            }

            if (sortSportOn !== undefined) {
                localVarQueryParameter['SortSportOn'] = sortSportOn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a sport
         * @param {CreateSportRequest} createSportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSportsPost: async (createSportRequest: CreateSportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSportRequest' is not null or undefined
            assertParamExists('adminSportsPost', 'createSportRequest', createSportRequest)
            const localVarPath = `/admin/sports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive a sport
         * @param {string} sportId 
         * @param {ArchiveRequest} archiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSportsSportIdArchivePatch: async (sportId: string, archiveRequest: ArchiveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sportId' is not null or undefined
            assertParamExists('adminSportsSportIdArchivePatch', 'sportId', sportId)
            // verify required parameter 'archiveRequest' is not null or undefined
            assertParamExists('adminSportsSportIdArchivePatch', 'archiveRequest', archiveRequest)
            const localVarPath = `/admin/sports/{sportId}/archive`
                .replace('{sportId}', encodeURIComponent(String(sportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(archiveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a sport by id
         * @param {string} sportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSportsSportIdGet: async (sportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sportId' is not null or undefined
            assertParamExists('adminSportsSportIdGet', 'sportId', sportId)
            const localVarPath = `/admin/sports/{sportId}`
                .replace('{sportId}', encodeURIComponent(String(sportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a sport
         * @param {string} sportId 
         * @param {UpdateSportRequest} updateSportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSportsSportIdPut: async (sportId: string, updateSportRequest: UpdateSportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sportId' is not null or undefined
            assertParamExists('adminSportsSportIdPut', 'sportId', sportId)
            // verify required parameter 'updateSportRequest' is not null or undefined
            assertParamExists('adminSportsSportIdPut', 'updateSportRequest', updateSportRequest)
            const localVarPath = `/admin/sports/{sportId}`
                .replace('{sportId}', encodeURIComponent(String(sportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a sport by id or slug
         * @param {string} sportIdentifier 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSportsSportTypesSportIdentifierGet: async (sportIdentifier: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sportIdentifier' is not null or undefined
            assertParamExists('adminSportsSportTypesSportIdentifierGet', 'sportIdentifier', sportIdentifier)
            const localVarPath = `/admin/sports/sport-types/{sportIdentifier}`
                .replace('{sportIdentifier}', encodeURIComponent(String(sportIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSportsApi - functional programming interface
 */
export const AdminSportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List of all sports
         * @param {string} [searchTerm] 
         * @param {boolean} [isArchived] 
         * @param {SortSportOn} [sortSportOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSportsGet(searchTerm?: string, isArchived?: boolean, sortSportOn?: SortSportOn, sortDirection?: SortDirection, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminSportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSportsGet(searchTerm, isArchived, sortSportOn, sortDirection, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSportsApi.adminSportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a sport
         * @param {CreateSportRequest} createSportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSportsPost(createSportRequest: CreateSportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSportsPost(createSportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSportsApi.adminSportsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archive a sport
         * @param {string} sportId 
         * @param {ArchiveRequest} archiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSportsSportIdArchivePatch(sportId: string, archiveRequest: ArchiveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSportsSportIdArchivePatch(sportId, archiveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSportsApi.adminSportsSportIdArchivePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a sport by id
         * @param {string} sportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSportsSportIdGet(sportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSportsSportIdGet(sportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSportsApi.adminSportsSportIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a sport
         * @param {string} sportId 
         * @param {UpdateSportRequest} updateSportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSportsSportIdPut(sportId: string, updateSportRequest: UpdateSportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSportsSportIdPut(sportId, updateSportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSportsApi.adminSportsSportIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a sport by id or slug
         * @param {string} sportIdentifier 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSportsSportTypesSportIdentifierGet(sportIdentifier: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSportsSportTypesSportIdentifierGet(sportIdentifier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSportsApi.adminSportsSportTypesSportIdentifierGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminSportsApi - factory interface
 */
export const AdminSportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSportsApiFp(configuration)
    return {
        /**
         * 
         * @summary List of all sports
         * @param {AdminSportsApiAdminSportsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSportsGet(requestParameters: AdminSportsApiAdminSportsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminSportResponse> {
            return localVarFp.adminSportsGet(requestParameters.searchTerm, requestParameters.isArchived, requestParameters.sortSportOn, requestParameters.sortDirection, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a sport
         * @param {AdminSportsApiAdminSportsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSportsPost(requestParameters: AdminSportsApiAdminSportsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminSportsPost(requestParameters.createSportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive a sport
         * @param {AdminSportsApiAdminSportsSportIdArchivePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSportsSportIdArchivePatch(requestParameters: AdminSportsApiAdminSportsSportIdArchivePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminSportsSportIdArchivePatch(requestParameters.sportId, requestParameters.archiveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a sport by id
         * @param {AdminSportsApiAdminSportsSportIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSportsSportIdGet(requestParameters: AdminSportsApiAdminSportsSportIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSportResponse> {
            return localVarFp.adminSportsSportIdGet(requestParameters.sportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a sport
         * @param {AdminSportsApiAdminSportsSportIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSportsSportIdPut(requestParameters: AdminSportsApiAdminSportsSportIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminSportsSportIdPut(requestParameters.sportId, requestParameters.updateSportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a sport by id or slug
         * @param {AdminSportsApiAdminSportsSportTypesSportIdentifierGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSportsSportTypesSportIdentifierGet(requestParameters: AdminSportsApiAdminSportsSportTypesSportIdentifierGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSportDto> {
            return localVarFp.adminSportsSportTypesSportIdentifierGet(requestParameters.sportIdentifier, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminSportsGet operation in AdminSportsApi.
 */
export interface AdminSportsApiAdminSportsGetRequest {
    readonly searchTerm?: string

    readonly isArchived?: boolean

    readonly sortSportOn?: SortSportOn

    readonly sortDirection?: SortDirection

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminSportsPost operation in AdminSportsApi.
 */
export interface AdminSportsApiAdminSportsPostRequest {
    readonly createSportRequest: CreateSportRequest
}

/**
 * Request parameters for adminSportsSportIdArchivePatch operation in AdminSportsApi.
 */
export interface AdminSportsApiAdminSportsSportIdArchivePatchRequest {
    readonly sportId: string

    readonly archiveRequest: ArchiveRequest
}

/**
 * Request parameters for adminSportsSportIdGet operation in AdminSportsApi.
 */
export interface AdminSportsApiAdminSportsSportIdGetRequest {
    readonly sportId: string
}

/**
 * Request parameters for adminSportsSportIdPut operation in AdminSportsApi.
 */
export interface AdminSportsApiAdminSportsSportIdPutRequest {
    readonly sportId: string

    readonly updateSportRequest: UpdateSportRequest
}

/**
 * Request parameters for adminSportsSportTypesSportIdentifierGet operation in AdminSportsApi.
 */
export interface AdminSportsApiAdminSportsSportTypesSportIdentifierGetRequest {
    readonly sportIdentifier: string
}

/**
 * AdminSportsApi - object-oriented interface
 */
export class AdminSportsApi extends BaseAPI {
    /**
     * 
     * @summary List of all sports
     * @param {AdminSportsApiAdminSportsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminSportsGet(requestParameters: AdminSportsApiAdminSportsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminSportsApiFp(this.configuration).adminSportsGet(requestParameters.searchTerm, requestParameters.isArchived, requestParameters.sortSportOn, requestParameters.sortDirection, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a sport
     * @param {AdminSportsApiAdminSportsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminSportsPost(requestParameters: AdminSportsApiAdminSportsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminSportsApiFp(this.configuration).adminSportsPost(requestParameters.createSportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive a sport
     * @param {AdminSportsApiAdminSportsSportIdArchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminSportsSportIdArchivePatch(requestParameters: AdminSportsApiAdminSportsSportIdArchivePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminSportsApiFp(this.configuration).adminSportsSportIdArchivePatch(requestParameters.sportId, requestParameters.archiveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a sport by id
     * @param {AdminSportsApiAdminSportsSportIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminSportsSportIdGet(requestParameters: AdminSportsApiAdminSportsSportIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminSportsApiFp(this.configuration).adminSportsSportIdGet(requestParameters.sportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a sport
     * @param {AdminSportsApiAdminSportsSportIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminSportsSportIdPut(requestParameters: AdminSportsApiAdminSportsSportIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminSportsApiFp(this.configuration).adminSportsSportIdPut(requestParameters.sportId, requestParameters.updateSportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a sport by id or slug
     * @param {AdminSportsApiAdminSportsSportTypesSportIdentifierGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminSportsSportTypesSportIdentifierGet(requestParameters: AdminSportsApiAdminSportsSportTypesSportIdentifierGetRequest, options?: RawAxiosRequestConfig) {
        return AdminSportsApiFp(this.configuration).adminSportsSportTypesSportIdentifierGet(requestParameters.sportIdentifier, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminTeamsApi - axios parameter creator
 */
export const AdminTeamsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search for a team by name externally.
         * @param {string} [sportSlug] The slug of sport
         * @param {string} [teamName] The team name to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsExternalGet: async (sportSlug?: string, teamName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/teams/external`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sportSlug !== undefined) {
                localVarQueryParameter['sportSlug'] = sportSlug;
            }

            if (teamName !== undefined) {
                localVarQueryParameter['teamName'] = teamName;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get team list.
         * @param {string} [searchTerm] 
         * @param {boolean} [isArchived] 
         * @param {Array<string>} [sportId] 
         * @param {SortTeamOn} [sortTeamOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {Array<string>} [country] 
         * @param {Array<number>} [tier] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsGet: async (searchTerm?: string, isArchived?: boolean, sportId?: Array<string>, sortTeamOn?: SortTeamOn, sortDirection?: SortDirection, country?: Array<string>, tier?: Array<number>, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['IsArchived'] = isArchived;
            }

            if (sportId) {
                localVarQueryParameter['SportId'] = sportId;
            }

            if (sortTeamOn !== undefined) {
                localVarQueryParameter['SortTeamOn'] = sortTeamOn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (country) {
                localVarQueryParameter['Country'] = country;
            }

            if (tier) {
                localVarQueryParameter['Tier'] = tier;
            }

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search for a team by name internally.
         * @param {string} [sportSlug] The slug of sport
         * @param {string} [teamName] The team name to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsInternalGet: async (sportSlug?: string, teamName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/teams/internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sportSlug !== undefined) {
                localVarQueryParameter['sportSlug'] = sportSlug;
            }

            if (teamName !== undefined) {
                localVarQueryParameter['teamName'] = teamName;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a team.
         * @param {CreateTeamRequest} createTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsPost: async (createTeamRequest: CreateTeamRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTeamRequest' is not null or undefined
            assertParamExists('adminTeamsPost', 'createTeamRequest', createTeamRequest)
            const localVarPath = `/admin/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTeamRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archives a team.
         * @param {string} teamId 
         * @param {ArchiveRequest} archiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdArchivePatch: async (teamId: string, archiveRequest: ArchiveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('adminTeamsTeamIdArchivePatch', 'teamId', teamId)
            // verify required parameter 'archiveRequest' is not null or undefined
            assertParamExists('adminTeamsTeamIdArchivePatch', 'archiveRequest', archiveRequest)
            const localVarPath = `/admin/teams/{teamId}/archive`
                .replace('{teamId}', encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(archiveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a teams\' roster for the fixtures\' season. The response includes the athletes with the media, if uploaded.
         * @param {string} teamId the provider slug
         * @param {string} fixtureId the id of the fixture
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdFixturesFixtureIdGet: async (teamId: string, fixtureId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('adminTeamsTeamIdFixturesFixtureIdGet', 'teamId', teamId)
            // verify required parameter 'fixtureId' is not null or undefined
            assertParamExists('adminTeamsTeamIdFixturesFixtureIdGet', 'fixtureId', fixtureId)
            const localVarPath = `/admin/teams/{teamId}/fixtures/{fixtureId}`
                .replace('{teamId}', encodeURIComponent(String(teamId)))
                .replace('{fixtureId}', encodeURIComponent(String(fixtureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all fixtures for a specific team within a date range.
         * @param {string} teamId the guid of the team for which to get fixtures
         * @param {Date} [startDate] The start date of the period.
         * @param {Date} [endDate] The end date of the period.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdFixturesGet: async (teamId: string, startDate?: Date, endDate?: Date, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('adminTeamsTeamIdFixturesGet', 'teamId', teamId)
            const localVarPath = `/admin/teams/{teamId}/fixtures`
                .replace('{teamId}', encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get team by id.
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdGet: async (teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('adminTeamsTeamIdGet', 'teamId', teamId)
            const localVarPath = `/admin/teams/{teamId}`
                .replace('{teamId}', encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update legacy attributes for a team. (menu structuring)
         * @param {string} teamId 
         * @param {UpdateTeamHeaderInfoRequest} updateTeamHeaderInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdLegacyPatch: async (teamId: string, updateTeamHeaderInfoRequest: UpdateTeamHeaderInfoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('adminTeamsTeamIdLegacyPatch', 'teamId', teamId)
            // verify required parameter 'updateTeamHeaderInfoRequest' is not null or undefined
            assertParamExists('adminTeamsTeamIdLegacyPatch', 'updateTeamHeaderInfoRequest', updateTeamHeaderInfoRequest)
            const localVarPath = `/admin/teams/{teamId}/legacy`
                .replace('{teamId}', encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTeamHeaderInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload team related media content.
         * @param {string} teamId the id of the team for which to upload media content
         * @param {UploadMediaContentRequestDto} uploadMediaContentRequestDto A cancellation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdMediaContentPost: async (teamId: string, uploadMediaContentRequestDto: UploadMediaContentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('adminTeamsTeamIdMediaContentPost', 'teamId', teamId)
            // verify required parameter 'uploadMediaContentRequestDto' is not null or undefined
            assertParamExists('adminTeamsTeamIdMediaContentPost', 'uploadMediaContentRequestDto', uploadMediaContentRequestDto)
            const localVarPath = `/admin/teams/{teamId}/media-content`
                .replace('{teamId}', encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadMediaContentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a team.
         * @param {string} teamId 
         * @param {UpdateTeamRequest} updateTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdPatch: async (teamId: string, updateTeamRequest: UpdateTeamRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('adminTeamsTeamIdPatch', 'teamId', teamId)
            // verify required parameter 'updateTeamRequest' is not null or undefined
            assertParamExists('adminTeamsTeamIdPatch', 'updateTeamRequest', updateTeamRequest)
            const localVarPath = `/admin/teams/{teamId}`
                .replace('{teamId}', encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTeamRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all seasons that a team has participated in.
         * @param {string} teamId The ID of the team for which all seasons are returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdSeasonsGet: async (teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('adminTeamsTeamIdSeasonsGet', 'teamId', teamId)
            const localVarPath = `/admin/teams/{teamId}/seasons`
                .replace('{teamId}', encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminTeamsApi - functional programming interface
 */
export const AdminTeamsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminTeamsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Search for a team by name externally.
         * @param {string} [sportSlug] The slug of sport
         * @param {string} [teamName] The team name to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTeamsExternalGet(sportSlug?: string, teamName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamsAggregateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTeamsExternalGet(sportSlug, teamName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTeamsApi.adminTeamsExternalGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get team list.
         * @param {string} [searchTerm] 
         * @param {boolean} [isArchived] 
         * @param {Array<string>} [sportId] 
         * @param {SortTeamOn} [sortTeamOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {Array<string>} [country] 
         * @param {Array<number>} [tier] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTeamsGet(searchTerm?: string, isArchived?: boolean, sportId?: Array<string>, sortTeamOn?: SortTeamOn, sortDirection?: SortDirection, country?: Array<string>, tier?: Array<number>, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminTeamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTeamsGet(searchTerm, isArchived, sportId, sortTeamOn, sortDirection, country, tier, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTeamsApi.adminTeamsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search for a team by name internally.
         * @param {string} [sportSlug] The slug of sport
         * @param {string} [teamName] The team name to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTeamsInternalGet(sportSlug?: string, teamName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamsAggregateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTeamsInternalGet(sportSlug, teamName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTeamsApi.adminTeamsInternalGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a team.
         * @param {CreateTeamRequest} createTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTeamsPost(createTeamRequest: CreateTeamRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTeamsPost(createTeamRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTeamsApi.adminTeamsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archives a team.
         * @param {string} teamId 
         * @param {ArchiveRequest} archiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTeamsTeamIdArchivePatch(teamId: string, archiveRequest: ArchiveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTeamsTeamIdArchivePatch(teamId, archiveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTeamsApi.adminTeamsTeamIdArchivePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a teams\' roster for the fixtures\' season. The response includes the athletes with the media, if uploaded.
         * @param {string} teamId the provider slug
         * @param {string} fixtureId the id of the fixture
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTeamsTeamIdFixturesFixtureIdGet(teamId: string, fixtureId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AthleteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTeamsTeamIdFixturesFixtureIdGet(teamId, fixtureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTeamsApi.adminTeamsTeamIdFixturesFixtureIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all fixtures for a specific team within a date range.
         * @param {string} teamId the guid of the team for which to get fixtures
         * @param {Date} [startDate] The start date of the period.
         * @param {Date} [endDate] The end date of the period.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTeamsTeamIdFixturesGet(teamId: string, startDate?: Date, endDate?: Date, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FixtureAggregateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTeamsTeamIdFixturesGet(teamId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTeamsApi.adminTeamsTeamIdFixturesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get team by id.
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTeamsTeamIdGet(teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTeamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTeamsTeamIdGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTeamsApi.adminTeamsTeamIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update legacy attributes for a team. (menu structuring)
         * @param {string} teamId 
         * @param {UpdateTeamHeaderInfoRequest} updateTeamHeaderInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTeamsTeamIdLegacyPatch(teamId: string, updateTeamHeaderInfoRequest: UpdateTeamHeaderInfoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTeamsTeamIdLegacyPatch(teamId, updateTeamHeaderInfoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTeamsApi.adminTeamsTeamIdLegacyPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload team related media content.
         * @param {string} teamId the id of the team for which to upload media content
         * @param {UploadMediaContentRequestDto} uploadMediaContentRequestDto A cancellation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTeamsTeamIdMediaContentPost(teamId: string, uploadMediaContentRequestDto: UploadMediaContentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTeamsTeamIdMediaContentPost(teamId, uploadMediaContentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTeamsApi.adminTeamsTeamIdMediaContentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a team.
         * @param {string} teamId 
         * @param {UpdateTeamRequest} updateTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTeamsTeamIdPatch(teamId: string, updateTeamRequest: UpdateTeamRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTeamsTeamIdPatch(teamId, updateTeamRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTeamsApi.adminTeamsTeamIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all seasons that a team has participated in.
         * @param {string} teamId The ID of the team for which all seasons are returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTeamsTeamIdSeasonsGet(teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeasonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTeamsTeamIdSeasonsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTeamsApi.adminTeamsTeamIdSeasonsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminTeamsApi - factory interface
 */
export const AdminTeamsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminTeamsApiFp(configuration)
    return {
        /**
         * 
         * @summary Search for a team by name externally.
         * @param {AdminTeamsApiAdminTeamsExternalGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsExternalGet(requestParameters: AdminTeamsApiAdminTeamsExternalGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TeamsAggregateDto> {
            return localVarFp.adminTeamsExternalGet(requestParameters.sportSlug, requestParameters.teamName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get team list.
         * @param {AdminTeamsApiAdminTeamsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsGet(requestParameters: AdminTeamsApiAdminTeamsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminTeamResponse> {
            return localVarFp.adminTeamsGet(requestParameters.searchTerm, requestParameters.isArchived, requestParameters.sportId, requestParameters.sortTeamOn, requestParameters.sortDirection, requestParameters.country, requestParameters.tier, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search for a team by name internally.
         * @param {AdminTeamsApiAdminTeamsInternalGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsInternalGet(requestParameters: AdminTeamsApiAdminTeamsInternalGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TeamsAggregateDto> {
            return localVarFp.adminTeamsInternalGet(requestParameters.sportSlug, requestParameters.teamName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a team.
         * @param {AdminTeamsApiAdminTeamsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsPost(requestParameters: AdminTeamsApiAdminTeamsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminTeamsPost(requestParameters.createTeamRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archives a team.
         * @param {AdminTeamsApiAdminTeamsTeamIdArchivePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdArchivePatch(requestParameters: AdminTeamsApiAdminTeamsTeamIdArchivePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminTeamsTeamIdArchivePatch(requestParameters.teamId, requestParameters.archiveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a teams\' roster for the fixtures\' season. The response includes the athletes with the media, if uploaded.
         * @param {AdminTeamsApiAdminTeamsTeamIdFixturesFixtureIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdFixturesFixtureIdGet(requestParameters: AdminTeamsApiAdminTeamsTeamIdFixturesFixtureIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AthleteDto>> {
            return localVarFp.adminTeamsTeamIdFixturesFixtureIdGet(requestParameters.teamId, requestParameters.fixtureId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all fixtures for a specific team within a date range.
         * @param {AdminTeamsApiAdminTeamsTeamIdFixturesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdFixturesGet(requestParameters: AdminTeamsApiAdminTeamsTeamIdFixturesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<FixtureAggregateDto>> {
            return localVarFp.adminTeamsTeamIdFixturesGet(requestParameters.teamId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get team by id.
         * @param {AdminTeamsApiAdminTeamsTeamIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdGet(requestParameters: AdminTeamsApiAdminTeamsTeamIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminTeamResponse> {
            return localVarFp.adminTeamsTeamIdGet(requestParameters.teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update legacy attributes for a team. (menu structuring)
         * @param {AdminTeamsApiAdminTeamsTeamIdLegacyPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdLegacyPatch(requestParameters: AdminTeamsApiAdminTeamsTeamIdLegacyPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamDto> {
            return localVarFp.adminTeamsTeamIdLegacyPatch(requestParameters.teamId, requestParameters.updateTeamHeaderInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload team related media content.
         * @param {AdminTeamsApiAdminTeamsTeamIdMediaContentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdMediaContentPost(requestParameters: AdminTeamsApiAdminTeamsTeamIdMediaContentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminTeamsTeamIdMediaContentPost(requestParameters.teamId, requestParameters.uploadMediaContentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a team.
         * @param {AdminTeamsApiAdminTeamsTeamIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdPatch(requestParameters: AdminTeamsApiAdminTeamsTeamIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminTeamsTeamIdPatch(requestParameters.teamId, requestParameters.updateTeamRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all seasons that a team has participated in.
         * @param {AdminTeamsApiAdminTeamsTeamIdSeasonsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdSeasonsGet(requestParameters: AdminTeamsApiAdminTeamsTeamIdSeasonsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SeasonDto>> {
            return localVarFp.adminTeamsTeamIdSeasonsGet(requestParameters.teamId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminTeamsExternalGet operation in AdminTeamsApi.
 */
export interface AdminTeamsApiAdminTeamsExternalGetRequest {
    /**
     * The slug of sport
     */
    readonly sportSlug?: string

    /**
     * The team name to search
     */
    readonly teamName?: string
}

/**
 * Request parameters for adminTeamsGet operation in AdminTeamsApi.
 */
export interface AdminTeamsApiAdminTeamsGetRequest {
    readonly searchTerm?: string

    readonly isArchived?: boolean

    readonly sportId?: Array<string>

    readonly sortTeamOn?: SortTeamOn

    readonly sortDirection?: SortDirection

    readonly country?: Array<string>

    readonly tier?: Array<number>

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminTeamsInternalGet operation in AdminTeamsApi.
 */
export interface AdminTeamsApiAdminTeamsInternalGetRequest {
    /**
     * The slug of sport
     */
    readonly sportSlug?: string

    /**
     * The team name to search
     */
    readonly teamName?: string
}

/**
 * Request parameters for adminTeamsPost operation in AdminTeamsApi.
 */
export interface AdminTeamsApiAdminTeamsPostRequest {
    readonly createTeamRequest: CreateTeamRequest
}

/**
 * Request parameters for adminTeamsTeamIdArchivePatch operation in AdminTeamsApi.
 */
export interface AdminTeamsApiAdminTeamsTeamIdArchivePatchRequest {
    readonly teamId: string

    readonly archiveRequest: ArchiveRequest
}

/**
 * Request parameters for adminTeamsTeamIdFixturesFixtureIdGet operation in AdminTeamsApi.
 */
export interface AdminTeamsApiAdminTeamsTeamIdFixturesFixtureIdGetRequest {
    /**
     * the provider slug
     */
    readonly teamId: string

    /**
     * the id of the fixture
     */
    readonly fixtureId: string
}

/**
 * Request parameters for adminTeamsTeamIdFixturesGet operation in AdminTeamsApi.
 */
export interface AdminTeamsApiAdminTeamsTeamIdFixturesGetRequest {
    /**
     * the guid of the team for which to get fixtures
     */
    readonly teamId: string

    /**
     * The start date of the period.
     */
    readonly startDate?: Date

    /**
     * The end date of the period.
     */
    readonly endDate?: Date
}

/**
 * Request parameters for adminTeamsTeamIdGet operation in AdminTeamsApi.
 */
export interface AdminTeamsApiAdminTeamsTeamIdGetRequest {
    readonly teamId: string
}

/**
 * Request parameters for adminTeamsTeamIdLegacyPatch operation in AdminTeamsApi.
 */
export interface AdminTeamsApiAdminTeamsTeamIdLegacyPatchRequest {
    /**
     * 
     */
    readonly teamId: string

    /**
     * 
     */
    readonly updateTeamHeaderInfoRequest: UpdateTeamHeaderInfoRequest
}

/**
 * Request parameters for adminTeamsTeamIdMediaContentPost operation in AdminTeamsApi.
 */
export interface AdminTeamsApiAdminTeamsTeamIdMediaContentPostRequest {
    /**
     * the id of the team for which to upload media content
     */
    readonly teamId: string

    /**
     * A cancellation token
     */
    readonly uploadMediaContentRequestDto: UploadMediaContentRequestDto
}

/**
 * Request parameters for adminTeamsTeamIdPatch operation in AdminTeamsApi.
 */
export interface AdminTeamsApiAdminTeamsTeamIdPatchRequest {
    readonly teamId: string

    readonly updateTeamRequest: UpdateTeamRequest
}

/**
 * Request parameters for adminTeamsTeamIdSeasonsGet operation in AdminTeamsApi.
 */
export interface AdminTeamsApiAdminTeamsTeamIdSeasonsGetRequest {
    /**
     * The ID of the team for which all seasons are returned
     */
    readonly teamId: string
}

/**
 * AdminTeamsApi - object-oriented interface
 */
export class AdminTeamsApi extends BaseAPI {
    /**
     * 
     * @summary Search for a team by name externally.
     * @param {AdminTeamsApiAdminTeamsExternalGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminTeamsExternalGet(requestParameters: AdminTeamsApiAdminTeamsExternalGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminTeamsApiFp(this.configuration).adminTeamsExternalGet(requestParameters.sportSlug, requestParameters.teamName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get team list.
     * @param {AdminTeamsApiAdminTeamsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminTeamsGet(requestParameters: AdminTeamsApiAdminTeamsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminTeamsApiFp(this.configuration).adminTeamsGet(requestParameters.searchTerm, requestParameters.isArchived, requestParameters.sportId, requestParameters.sortTeamOn, requestParameters.sortDirection, requestParameters.country, requestParameters.tier, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search for a team by name internally.
     * @param {AdminTeamsApiAdminTeamsInternalGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminTeamsInternalGet(requestParameters: AdminTeamsApiAdminTeamsInternalGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminTeamsApiFp(this.configuration).adminTeamsInternalGet(requestParameters.sportSlug, requestParameters.teamName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a team.
     * @param {AdminTeamsApiAdminTeamsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminTeamsPost(requestParameters: AdminTeamsApiAdminTeamsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminTeamsApiFp(this.configuration).adminTeamsPost(requestParameters.createTeamRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archives a team.
     * @param {AdminTeamsApiAdminTeamsTeamIdArchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminTeamsTeamIdArchivePatch(requestParameters: AdminTeamsApiAdminTeamsTeamIdArchivePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminTeamsApiFp(this.configuration).adminTeamsTeamIdArchivePatch(requestParameters.teamId, requestParameters.archiveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a teams\' roster for the fixtures\' season. The response includes the athletes with the media, if uploaded.
     * @param {AdminTeamsApiAdminTeamsTeamIdFixturesFixtureIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminTeamsTeamIdFixturesFixtureIdGet(requestParameters: AdminTeamsApiAdminTeamsTeamIdFixturesFixtureIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminTeamsApiFp(this.configuration).adminTeamsTeamIdFixturesFixtureIdGet(requestParameters.teamId, requestParameters.fixtureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all fixtures for a specific team within a date range.
     * @param {AdminTeamsApiAdminTeamsTeamIdFixturesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminTeamsTeamIdFixturesGet(requestParameters: AdminTeamsApiAdminTeamsTeamIdFixturesGetRequest, options?: RawAxiosRequestConfig) {
        return AdminTeamsApiFp(this.configuration).adminTeamsTeamIdFixturesGet(requestParameters.teamId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get team by id.
     * @param {AdminTeamsApiAdminTeamsTeamIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminTeamsTeamIdGet(requestParameters: AdminTeamsApiAdminTeamsTeamIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminTeamsApiFp(this.configuration).adminTeamsTeamIdGet(requestParameters.teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update legacy attributes for a team. (menu structuring)
     * @param {AdminTeamsApiAdminTeamsTeamIdLegacyPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminTeamsTeamIdLegacyPatch(requestParameters: AdminTeamsApiAdminTeamsTeamIdLegacyPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminTeamsApiFp(this.configuration).adminTeamsTeamIdLegacyPatch(requestParameters.teamId, requestParameters.updateTeamHeaderInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload team related media content.
     * @param {AdminTeamsApiAdminTeamsTeamIdMediaContentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminTeamsTeamIdMediaContentPost(requestParameters: AdminTeamsApiAdminTeamsTeamIdMediaContentPostRequest, options?: RawAxiosRequestConfig) {
        return AdminTeamsApiFp(this.configuration).adminTeamsTeamIdMediaContentPost(requestParameters.teamId, requestParameters.uploadMediaContentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a team.
     * @param {AdminTeamsApiAdminTeamsTeamIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminTeamsTeamIdPatch(requestParameters: AdminTeamsApiAdminTeamsTeamIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminTeamsApiFp(this.configuration).adminTeamsTeamIdPatch(requestParameters.teamId, requestParameters.updateTeamRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all seasons that a team has participated in.
     * @param {AdminTeamsApiAdminTeamsTeamIdSeasonsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminTeamsTeamIdSeasonsGet(requestParameters: AdminTeamsApiAdminTeamsTeamIdSeasonsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminTeamsApiFp(this.configuration).adminTeamsTeamIdSeasonsGet(requestParameters.teamId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AthletesApi - axios parameter creator
 */
export const AthletesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get athlete details.
         * @param {string} athleteId 
         * @param {string} [fixtureId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        athletesAthleteIdDetailsGet: async (athleteId: string, fixtureId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'athleteId' is not null or undefined
            assertParamExists('athletesAthleteIdDetailsGet', 'athleteId', athleteId)
            const localVarPath = `/athletes/{athleteId}/details`
                .replace('{athleteId}', encodeURIComponent(String(athleteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fixtureId !== undefined) {
                localVarQueryParameter['fixtureId'] = fixtureId;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch an athlete by id or slug.
         * @param {string} athleteId The id of the athlete to edit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        athletesAthleteIdGet: async (athleteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'athleteId' is not null or undefined
            assertParamExists('athletesAthleteIdGet', 'athleteId', athleteId)
            const localVarPath = `/athletes/{athleteId}`
                .replace('{athleteId}', encodeURIComponent(String(athleteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The searchTerm parameter will decide if this is a search or just a get. The searchTerm will decide (through a fuzzy search) what entities are returned. You can make use of the offSet and pageSize parameters to decide how many items you want to be returned, and how many should be skipped before returning.
         * @summary Get all athletes.
         * @param {string} [sportSlug] The sport to fetch athletes for
         * @param {number} [offSet] The amount of entities that should be skipped. Should be 0 or higher
         * @param {number} [pageSize] The amount of results to return per page. Should be 1 or higher
         * @param {string} [searchTerm] Optional: the search term that is used to search on athletes display name or their actual name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        athletesGet: async (sportSlug?: string, offSet?: number, pageSize?: number, searchTerm?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/athletes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sportSlug !== undefined) {
                localVarQueryParameter['sportSlug'] = sportSlug;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AthletesApi - functional programming interface
 */
export const AthletesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AthletesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get athlete details.
         * @param {string} athleteId 
         * @param {string} [fixtureId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async athletesAthleteIdDetailsGet(athleteId: string, fixtureId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AthleteDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.athletesAthleteIdDetailsGet(athleteId, fixtureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AthletesApi.athletesAthleteIdDetailsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch an athlete by id or slug.
         * @param {string} athleteId The id of the athlete to edit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async athletesAthleteIdGet(athleteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AthleteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.athletesAthleteIdGet(athleteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AthletesApi.athletesAthleteIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The searchTerm parameter will decide if this is a search or just a get. The searchTerm will decide (through a fuzzy search) what entities are returned. You can make use of the offSet and pageSize parameters to decide how many items you want to be returned, and how many should be skipped before returning.
         * @summary Get all athletes.
         * @param {string} [sportSlug] The sport to fetch athletes for
         * @param {number} [offSet] The amount of entities that should be skipped. Should be 0 or higher
         * @param {number} [pageSize] The amount of results to return per page. Should be 1 or higher
         * @param {string} [searchTerm] Optional: the search term that is used to search on athletes display name or their actual name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async athletesGet(sportSlug?: string, offSet?: number, pageSize?: number, searchTerm?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAthleteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.athletesGet(sportSlug, offSet, pageSize, searchTerm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AthletesApi.athletesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AthletesApi - factory interface
 */
export const AthletesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AthletesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get athlete details.
         * @param {AthletesApiAthletesAthleteIdDetailsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        athletesAthleteIdDetailsGet(requestParameters: AthletesApiAthletesAthleteIdDetailsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AthleteDetailsDto> {
            return localVarFp.athletesAthleteIdDetailsGet(requestParameters.athleteId, requestParameters.fixtureId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch an athlete by id or slug.
         * @param {AthletesApiAthletesAthleteIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        athletesAthleteIdGet(requestParameters: AthletesApiAthletesAthleteIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AthleteDto> {
            return localVarFp.athletesAthleteIdGet(requestParameters.athleteId, options).then((request) => request(axios, basePath));
        },
        /**
         * The searchTerm parameter will decide if this is a search or just a get. The searchTerm will decide (through a fuzzy search) what entities are returned. You can make use of the offSet and pageSize parameters to decide how many items you want to be returned, and how many should be skipped before returning.
         * @summary Get all athletes.
         * @param {AthletesApiAthletesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        athletesGet(requestParameters: AthletesApiAthletesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAthleteDto> {
            return localVarFp.athletesGet(requestParameters.sportSlug, requestParameters.offSet, requestParameters.pageSize, requestParameters.searchTerm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for athletesAthleteIdDetailsGet operation in AthletesApi.
 */
export interface AthletesApiAthletesAthleteIdDetailsGetRequest {
    /**
     * 
     */
    readonly athleteId: string

    /**
     * 
     */
    readonly fixtureId?: string
}

/**
 * Request parameters for athletesAthleteIdGet operation in AthletesApi.
 */
export interface AthletesApiAthletesAthleteIdGetRequest {
    /**
     * The id of the athlete to edit
     */
    readonly athleteId: string
}

/**
 * Request parameters for athletesGet operation in AthletesApi.
 */
export interface AthletesApiAthletesGetRequest {
    /**
     * The sport to fetch athletes for
     */
    readonly sportSlug?: string

    /**
     * The amount of entities that should be skipped. Should be 0 or higher
     */
    readonly offSet?: number

    /**
     * The amount of results to return per page. Should be 1 or higher
     */
    readonly pageSize?: number

    /**
     * Optional: the search term that is used to search on athletes display name or their actual name
     */
    readonly searchTerm?: string
}

/**
 * AthletesApi - object-oriented interface
 */
export class AthletesApi extends BaseAPI {
    /**
     * 
     * @summary Get athlete details.
     * @param {AthletesApiAthletesAthleteIdDetailsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public athletesAthleteIdDetailsGet(requestParameters: AthletesApiAthletesAthleteIdDetailsGetRequest, options?: RawAxiosRequestConfig) {
        return AthletesApiFp(this.configuration).athletesAthleteIdDetailsGet(requestParameters.athleteId, requestParameters.fixtureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch an athlete by id or slug.
     * @param {AthletesApiAthletesAthleteIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public athletesAthleteIdGet(requestParameters: AthletesApiAthletesAthleteIdGetRequest, options?: RawAxiosRequestConfig) {
        return AthletesApiFp(this.configuration).athletesAthleteIdGet(requestParameters.athleteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The searchTerm parameter will decide if this is a search or just a get. The searchTerm will decide (through a fuzzy search) what entities are returned. You can make use of the offSet and pageSize parameters to decide how many items you want to be returned, and how many should be skipped before returning.
     * @summary Get all athletes.
     * @param {AthletesApiAthletesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public athletesGet(requestParameters: AthletesApiAthletesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AthletesApiFp(this.configuration).athletesGet(requestParameters.sportSlug, requestParameters.offSet, requestParameters.pageSize, requestParameters.searchTerm, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CronApi - axios parameter creator
 */
export const CronApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [daysOld] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHistoricExternalFixtureResponsesPost: async (daysOld?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/delete-historic-external-fixture-responses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (daysOld !== undefined) {
                localVarQueryParameter['daysOld'] = daysOld;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refetchStatisticsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/refetch-statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [numberOfFixtures] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncActiveFixturesPost: async (numberOfFixtures?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sync-active-fixtures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (numberOfFixtures !== undefined) {
                localVarQueryParameter['numberOfFixtures'] = numberOfFixtures;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [numberOfRostersToSync] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDefaultRostersPost: async (numberOfRostersToSync?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sync-default-rosters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (numberOfRostersToSync !== undefined) {
                localVarQueryParameter['numberOfRostersToSync'] = numberOfRostersToSync;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [numberOfFixtures] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncEndingFixturesPost: async (numberOfFixtures?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sync-ending-fixtures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (numberOfFixtures !== undefined) {
                localVarQueryParameter['numberOfFixtures'] = numberOfFixtures;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [numberOfFixtures] 
         * @param {number} [startsBeforeDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncScheduledFixturesPost: async (numberOfFixtures?: number, startsBeforeDays?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sync-scheduled-fixtures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (numberOfFixtures !== undefined) {
                localVarQueryParameter['numberOfFixtures'] = numberOfFixtures;
            }

            if (startsBeforeDays !== undefined) {
                localVarQueryParameter['startsBeforeDays'] = startsBeforeDays;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [numberOfFixtures] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncUpcomingFixturesPost: async (numberOfFixtures?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sync-upcoming-fixtures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (numberOfFixtures !== undefined) {
                localVarQueryParameter['numberOfFixtures'] = numberOfFixtures;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Cronjob] Trigger preloading routine for each team that has preloading enabled.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsPreloadingPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/teams-preloading`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerAthleteFixtureStatisticsGenerationPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trigger-athlete-fixture-statistics-generation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Cronjob] Trigger fixture report generation for fixtures that ended X hours ago.
         * @param {number} [hoursAfterEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerFixtureReportGenerationPost: async (hoursAfterEnd?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trigger-fixture-report-generation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hoursAfterEnd !== undefined) {
                localVarQueryParameter['hoursAfterEnd'] = hoursAfterEnd;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CronApi - functional programming interface
 */
export const CronApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CronApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [daysOld] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHistoricExternalFixtureResponsesPost(daysOld?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHistoricExternalFixtureResponsesPost(daysOld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.deleteHistoricExternalFixtureResponsesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refetchStatisticsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refetchStatisticsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.refetchStatisticsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [numberOfFixtures] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncActiveFixturesPost(numberOfFixtures?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncActiveFixturesPost(numberOfFixtures, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.syncActiveFixturesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [numberOfRostersToSync] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncDefaultRostersPost(numberOfRostersToSync?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncDefaultRostersPost(numberOfRostersToSync, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.syncDefaultRostersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [numberOfFixtures] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncEndingFixturesPost(numberOfFixtures?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncEndingFixturesPost(numberOfFixtures, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.syncEndingFixturesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [numberOfFixtures] 
         * @param {number} [startsBeforeDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncScheduledFixturesPost(numberOfFixtures?: number, startsBeforeDays?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncScheduledFixturesPost(numberOfFixtures, startsBeforeDays, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.syncScheduledFixturesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [numberOfFixtures] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncUpcomingFixturesPost(numberOfFixtures?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncUpcomingFixturesPost(numberOfFixtures, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.syncUpcomingFixturesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Cronjob] Trigger preloading routine for each team that has preloading enabled.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teamsPreloadingPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teamsPreloadingPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.teamsPreloadingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerAthleteFixtureStatisticsGenerationPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerAthleteFixtureStatisticsGenerationPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.triggerAthleteFixtureStatisticsGenerationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Cronjob] Trigger fixture report generation for fixtures that ended X hours ago.
         * @param {number} [hoursAfterEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerFixtureReportGenerationPost(hoursAfterEnd?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerFixtureReportGenerationPost(hoursAfterEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.triggerFixtureReportGenerationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CronApi - factory interface
 */
export const CronApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CronApiFp(configuration)
    return {
        /**
         * 
         * @param {CronApiDeleteHistoricExternalFixtureResponsesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHistoricExternalFixtureResponsesPost(requestParameters: CronApiDeleteHistoricExternalFixtureResponsesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteHistoricExternalFixtureResponsesPost(requestParameters.daysOld, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refetchStatisticsPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.refetchStatisticsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CronApiSyncActiveFixturesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncActiveFixturesPost(requestParameters: CronApiSyncActiveFixturesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncActiveFixturesPost(requestParameters.numberOfFixtures, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CronApiSyncDefaultRostersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDefaultRostersPost(requestParameters: CronApiSyncDefaultRostersPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncDefaultRostersPost(requestParameters.numberOfRostersToSync, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CronApiSyncEndingFixturesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncEndingFixturesPost(requestParameters: CronApiSyncEndingFixturesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncEndingFixturesPost(requestParameters.numberOfFixtures, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CronApiSyncScheduledFixturesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncScheduledFixturesPost(requestParameters: CronApiSyncScheduledFixturesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncScheduledFixturesPost(requestParameters.numberOfFixtures, requestParameters.startsBeforeDays, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CronApiSyncUpcomingFixturesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncUpcomingFixturesPost(requestParameters: CronApiSyncUpcomingFixturesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncUpcomingFixturesPost(requestParameters.numberOfFixtures, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Cronjob] Trigger preloading routine for each team that has preloading enabled.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsPreloadingPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.teamsPreloadingPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerAthleteFixtureStatisticsGenerationPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.triggerAthleteFixtureStatisticsGenerationPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Cronjob] Trigger fixture report generation for fixtures that ended X hours ago.
         * @param {CronApiTriggerFixtureReportGenerationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerFixtureReportGenerationPost(requestParameters: CronApiTriggerFixtureReportGenerationPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.triggerFixtureReportGenerationPost(requestParameters.hoursAfterEnd, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteHistoricExternalFixtureResponsesPost operation in CronApi.
 */
export interface CronApiDeleteHistoricExternalFixtureResponsesPostRequest {
    readonly daysOld?: number
}

/**
 * Request parameters for syncActiveFixturesPost operation in CronApi.
 */
export interface CronApiSyncActiveFixturesPostRequest {
    readonly numberOfFixtures?: number
}

/**
 * Request parameters for syncDefaultRostersPost operation in CronApi.
 */
export interface CronApiSyncDefaultRostersPostRequest {
    readonly numberOfRostersToSync?: number
}

/**
 * Request parameters for syncEndingFixturesPost operation in CronApi.
 */
export interface CronApiSyncEndingFixturesPostRequest {
    readonly numberOfFixtures?: number
}

/**
 * Request parameters for syncScheduledFixturesPost operation in CronApi.
 */
export interface CronApiSyncScheduledFixturesPostRequest {
    readonly numberOfFixtures?: number

    readonly startsBeforeDays?: number
}

/**
 * Request parameters for syncUpcomingFixturesPost operation in CronApi.
 */
export interface CronApiSyncUpcomingFixturesPostRequest {
    readonly numberOfFixtures?: number
}

/**
 * Request parameters for triggerFixtureReportGenerationPost operation in CronApi.
 */
export interface CronApiTriggerFixtureReportGenerationPostRequest {
    readonly hoursAfterEnd?: number
}

/**
 * CronApi - object-oriented interface
 */
export class CronApi extends BaseAPI {
    /**
     * 
     * @param {CronApiDeleteHistoricExternalFixtureResponsesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteHistoricExternalFixtureResponsesPost(requestParameters: CronApiDeleteHistoricExternalFixtureResponsesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).deleteHistoricExternalFixtureResponsesPost(requestParameters.daysOld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public refetchStatisticsPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).refetchStatisticsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CronApiSyncActiveFixturesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public syncActiveFixturesPost(requestParameters: CronApiSyncActiveFixturesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).syncActiveFixturesPost(requestParameters.numberOfFixtures, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CronApiSyncDefaultRostersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public syncDefaultRostersPost(requestParameters: CronApiSyncDefaultRostersPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).syncDefaultRostersPost(requestParameters.numberOfRostersToSync, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CronApiSyncEndingFixturesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public syncEndingFixturesPost(requestParameters: CronApiSyncEndingFixturesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).syncEndingFixturesPost(requestParameters.numberOfFixtures, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CronApiSyncScheduledFixturesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public syncScheduledFixturesPost(requestParameters: CronApiSyncScheduledFixturesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).syncScheduledFixturesPost(requestParameters.numberOfFixtures, requestParameters.startsBeforeDays, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CronApiSyncUpcomingFixturesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public syncUpcomingFixturesPost(requestParameters: CronApiSyncUpcomingFixturesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).syncUpcomingFixturesPost(requestParameters.numberOfFixtures, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Cronjob] Trigger preloading routine for each team that has preloading enabled.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public teamsPreloadingPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).teamsPreloadingPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public triggerAthleteFixtureStatisticsGenerationPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).triggerAthleteFixtureStatisticsGenerationPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Cronjob] Trigger fixture report generation for fixtures that ended X hours ago.
     * @param {CronApiTriggerFixtureReportGenerationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public triggerFixtureReportGenerationPost(requestParameters: CronApiTriggerFixtureReportGenerationPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).triggerFixtureReportGenerationPost(requestParameters.hoursAfterEnd, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FixturesApi - axios parameter creator
 */
export const FixturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get fixture by id
         * @param {string} fixtureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixturesFixtureIdGet: async (fixtureId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fixtureId' is not null or undefined
            assertParamExists('fixturesFixtureIdGet', 'fixtureId', fixtureId)
            const localVarPath = `/fixtures/{fixtureId}`
                .replace('{fixtureId}', encodeURIComponent(String(fixtureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the season by fixture
         * @param {string} fixtureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixturesFixtureIdSeasonGet: async (fixtureId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fixtureId' is not null or undefined
            assertParamExists('fixturesFixtureIdSeasonGet', 'fixtureId', fixtureId)
            const localVarPath = `/fixtures/{fixtureId}/season`
                .replace('{fixtureId}', encodeURIComponent(String(fixtureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FixturesApi - functional programming interface
 */
export const FixturesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FixturesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get fixture by id
         * @param {string} fixtureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fixturesFixtureIdGet(fixtureId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FixtureAggregateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fixturesFixtureIdGet(fixtureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FixturesApi.fixturesFixtureIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the season by fixture
         * @param {string} fixtureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fixturesFixtureIdSeasonGet(fixtureId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeasonDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fixturesFixtureIdSeasonGet(fixtureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FixturesApi.fixturesFixtureIdSeasonGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FixturesApi - factory interface
 */
export const FixturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FixturesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get fixture by id
         * @param {FixturesApiFixturesFixtureIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixturesFixtureIdGet(requestParameters: FixturesApiFixturesFixtureIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FixtureAggregateDto> {
            return localVarFp.fixturesFixtureIdGet(requestParameters.fixtureId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the season by fixture
         * @param {FixturesApiFixturesFixtureIdSeasonGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixturesFixtureIdSeasonGet(requestParameters: FixturesApiFixturesFixtureIdSeasonGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SeasonDto> {
            return localVarFp.fixturesFixtureIdSeasonGet(requestParameters.fixtureId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for fixturesFixtureIdGet operation in FixturesApi.
 */
export interface FixturesApiFixturesFixtureIdGetRequest {
    /**
     * 
     */
    readonly fixtureId: string
}

/**
 * Request parameters for fixturesFixtureIdSeasonGet operation in FixturesApi.
 */
export interface FixturesApiFixturesFixtureIdSeasonGetRequest {
    /**
     * 
     */
    readonly fixtureId: string
}

/**
 * FixturesApi - object-oriented interface
 */
export class FixturesApi extends BaseAPI {
    /**
     * 
     * @summary Get fixture by id
     * @param {FixturesApiFixturesFixtureIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fixturesFixtureIdGet(requestParameters: FixturesApiFixturesFixtureIdGetRequest, options?: RawAxiosRequestConfig) {
        return FixturesApiFp(this.configuration).fixturesFixtureIdGet(requestParameters.fixtureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the season by fixture
     * @param {FixturesApiFixturesFixtureIdSeasonGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fixturesFixtureIdSeasonGet(requestParameters: FixturesApiFixturesFixtureIdSeasonGetRequest, options?: RawAxiosRequestConfig) {
        return FixturesApiFp(this.configuration).fixturesFixtureIdSeasonGet(requestParameters.fixtureId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LeaguesApi - axios parameter creator
 */
export const LeaguesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns leagues for multiple fixtures
         * @param {Array<string> | null} [requestBody] A cancellation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaguesByFixtureIdsPost: async (requestBody?: Array<string> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/leagues/byFixtureIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a PaginatedList of all leagues
         * @param {string} [searchTerm] 
         * @param {number} [offSet] The amount of entities that should be skipped. Should be 0 or higher
         * @param {number} [pageSize] The amount of results to return per page. Should be 1 or higher
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaguesGet: async (searchTerm?: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/leagues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get league by id
         * @param {string} leagueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaguesLeagueIdGet: async (leagueId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leagueId' is not null or undefined
            assertParamExists('leaguesLeagueIdGet', 'leagueId', leagueId)
            const localVarPath = `/leagues/{leagueId}`
                .replace('{leagueId}', encodeURIComponent(String(leagueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeaguesApi - functional programming interface
 */
export const LeaguesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeaguesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns leagues for multiple fixtures
         * @param {Array<string> | null} [requestBody] A cancellation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaguesByFixtureIdsPost(requestBody?: Array<string> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LeagueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaguesByFixtureIdsPost(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeaguesApi.leaguesByFixtureIdsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a PaginatedList of all leagues
         * @param {string} [searchTerm] 
         * @param {number} [offSet] The amount of entities that should be skipped. Should be 0 or higher
         * @param {number} [pageSize] The amount of results to return per page. Should be 1 or higher
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaguesGet(searchTerm?: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfLeagueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaguesGet(searchTerm, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeaguesApi.leaguesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get league by id
         * @param {string} leagueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaguesLeagueIdGet(leagueId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeagueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaguesLeagueIdGet(leagueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeaguesApi.leaguesLeagueIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LeaguesApi - factory interface
 */
export const LeaguesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeaguesApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns leagues for multiple fixtures
         * @param {LeaguesApiLeaguesByFixtureIdsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaguesByFixtureIdsPost(requestParameters: LeaguesApiLeaguesByFixtureIdsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<LeagueDto>> {
            return localVarFp.leaguesByFixtureIdsPost(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a PaginatedList of all leagues
         * @param {LeaguesApiLeaguesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaguesGet(requestParameters: LeaguesApiLeaguesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfLeagueDto> {
            return localVarFp.leaguesGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get league by id
         * @param {LeaguesApiLeaguesLeagueIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaguesLeagueIdGet(requestParameters: LeaguesApiLeaguesLeagueIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<LeagueDto> {
            return localVarFp.leaguesLeagueIdGet(requestParameters.leagueId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for leaguesByFixtureIdsPost operation in LeaguesApi.
 */
export interface LeaguesApiLeaguesByFixtureIdsPostRequest {
    /**
     * A cancellation token
     */
    readonly requestBody?: Array<string> | null
}

/**
 * Request parameters for leaguesGet operation in LeaguesApi.
 */
export interface LeaguesApiLeaguesGetRequest {
    /**
     * 
     */
    readonly searchTerm?: string

    /**
     * The amount of entities that should be skipped. Should be 0 or higher
     */
    readonly offSet?: number

    /**
     * The amount of results to return per page. Should be 1 or higher
     */
    readonly pageSize?: number
}

/**
 * Request parameters for leaguesLeagueIdGet operation in LeaguesApi.
 */
export interface LeaguesApiLeaguesLeagueIdGetRequest {
    /**
     * 
     */
    readonly leagueId: string
}

/**
 * LeaguesApi - object-oriented interface
 */
export class LeaguesApi extends BaseAPI {
    /**
     * 
     * @summary Returns leagues for multiple fixtures
     * @param {LeaguesApiLeaguesByFixtureIdsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leaguesByFixtureIdsPost(requestParameters: LeaguesApiLeaguesByFixtureIdsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return LeaguesApiFp(this.configuration).leaguesByFixtureIdsPost(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a PaginatedList of all leagues
     * @param {LeaguesApiLeaguesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leaguesGet(requestParameters: LeaguesApiLeaguesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return LeaguesApiFp(this.configuration).leaguesGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get league by id
     * @param {LeaguesApiLeaguesLeagueIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leaguesLeagueIdGet(requestParameters: LeaguesApiLeaguesLeagueIdGetRequest, options?: RawAxiosRequestConfig) {
        return LeaguesApiFp(this.configuration).leaguesLeagueIdGet(requestParameters.leagueId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RostersApi - axios parameter creator
 */
export const RostersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} teamId 
         * @param {string} seasonId 
         * @param {string} leagueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGet: async (teamId: string, seasonId: string, leagueId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('rostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGet', 'teamId', teamId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('rostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGet', 'seasonId', seasonId)
            // verify required parameter 'leagueId' is not null or undefined
            assertParamExists('rostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGet', 'leagueId', leagueId)
            const localVarPath = `/rosters/teams/{teamId}/seasons/{seasonId}/leagues/{leagueId}`
                .replace('{teamId}', encodeURIComponent(String(teamId)))
                .replace('{seasonId}', encodeURIComponent(String(seasonId)))
                .replace('{leagueId}', encodeURIComponent(String(leagueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RostersApi - functional programming interface
 */
export const RostersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RostersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} teamId 
         * @param {string} seasonId 
         * @param {string} leagueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGet(teamId: string, seasonId: string, leagueId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RosterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGet(teamId, seasonId, leagueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RostersApi.rostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RostersApi - factory interface
 */
export const RostersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RostersApiFp(configuration)
    return {
        /**
         * 
         * @param {RostersApiRostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGet(requestParameters: RostersApiRostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RosterDto> {
            return localVarFp.rostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGet(requestParameters.teamId, requestParameters.seasonId, requestParameters.leagueId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for rostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGet operation in RostersApi.
 */
export interface RostersApiRostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGetRequest {
    readonly teamId: string

    readonly seasonId: string

    readonly leagueId: string
}

/**
 * RostersApi - object-oriented interface
 */
export class RostersApi extends BaseAPI {
    /**
     * 
     * @param {RostersApiRostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGet(requestParameters: RostersApiRostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGetRequest, options?: RawAxiosRequestConfig) {
        return RostersApiFp(this.configuration).rostersTeamsTeamIdSeasonsSeasonIdLeaguesLeagueIdGet(requestParameters.teamId, requestParameters.seasonId, requestParameters.leagueId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SeasonsApi - axios parameter creator
 */
export const SeasonsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns a PaginatedList of all seasons from a league with id leagueId
         * @param {string} leagueId The Id of a league for which all seasons are returned
         * @param {number} [offSet] The amount of entities that should be skipped. Should be 0 or higher
         * @param {number} [pageSize] The amount of results to return per page. Should be 1 or higher
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaguesLeagueIdSeasonsGet: async (leagueId: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leagueId' is not null or undefined
            assertParamExists('leaguesLeagueIdSeasonsGet', 'leagueId', leagueId)
            const localVarPath = `/leagues/{leagueId}/seasons`
                .replace('{leagueId}', encodeURIComponent(String(leagueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SeasonsApi - functional programming interface
 */
export const SeasonsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SeasonsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns a PaginatedList of all seasons from a league with id leagueId
         * @param {string} leagueId The Id of a league for which all seasons are returned
         * @param {number} [offSet] The amount of entities that should be skipped. Should be 0 or higher
         * @param {number} [pageSize] The amount of results to return per page. Should be 1 or higher
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaguesLeagueIdSeasonsGet(leagueId: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfSeasonDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaguesLeagueIdSeasonsGet(leagueId, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeasonsApi.leaguesLeagueIdSeasonsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SeasonsApi - factory interface
 */
export const SeasonsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SeasonsApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns a PaginatedList of all seasons from a league with id leagueId
         * @param {SeasonsApiLeaguesLeagueIdSeasonsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaguesLeagueIdSeasonsGet(requestParameters: SeasonsApiLeaguesLeagueIdSeasonsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfSeasonDto> {
            return localVarFp.leaguesLeagueIdSeasonsGet(requestParameters.leagueId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for leaguesLeagueIdSeasonsGet operation in SeasonsApi.
 */
export interface SeasonsApiLeaguesLeagueIdSeasonsGetRequest {
    /**
     * The Id of a league for which all seasons are returned
     */
    readonly leagueId: string

    /**
     * The amount of entities that should be skipped. Should be 0 or higher
     */
    readonly offSet?: number

    /**
     * The amount of results to return per page. Should be 1 or higher
     */
    readonly pageSize?: number
}

/**
 * SeasonsApi - object-oriented interface
 */
export class SeasonsApi extends BaseAPI {
    /**
     * 
     * @summary Returns a PaginatedList of all seasons from a league with id leagueId
     * @param {SeasonsApiLeaguesLeagueIdSeasonsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leaguesLeagueIdSeasonsGet(requestParameters: SeasonsApiLeaguesLeagueIdSeasonsGetRequest, options?: RawAxiosRequestConfig) {
        return SeasonsApiFp(this.configuration).leaguesLeagueIdSeasonsGet(requestParameters.leagueId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeamsApi - axios parameter creator
 */
export const TeamsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns a list of category objects which potentially represent a country that each contain a list of partnered teams.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsCategoriesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/teams/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of country objects that each contain a list of partnered teams.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsCountriesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/teams/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary RPC endpoint for fetching teams info from SportMonks for the ML event yield model
         * @param {string} [featuredTeamId] Guid of the featured team
         * @param {string} [participatingTeamId] Guid of the participating team
         * @param {string} [featuredTeamExternalId] SportMonks Id for the featured team
         * @param {string} [participatingTeamExternalId] SportMonks Id for the participating team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsEventYieldGet: async (featuredTeamId?: string, participatingTeamId?: string, featuredTeamExternalId?: string, participatingTeamExternalId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/teams/event-yield`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (featuredTeamId !== undefined) {
                localVarQueryParameter['featuredTeamId'] = featuredTeamId;
            }

            if (participatingTeamId !== undefined) {
                localVarQueryParameter['participatingTeamId'] = participatingTeamId;
            }

            if (featuredTeamExternalId !== undefined) {
                localVarQueryParameter['featuredTeamExternalId'] = featuredTeamExternalId;
            }

            if (participatingTeamExternalId !== undefined) {
                localVarQueryParameter['participatingTeamExternalId'] = participatingTeamExternalId;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all teams for a sport.
         * @param {string} [sportSlug] the slug of the sport for which to get all the teams
         * @param {string} [searchTerm] searchTerm used to filter against team name.
         * @param {string} [gender] 
         * @param {boolean} [isArchived] 
         * @param {number} [offset] The amount of items to skip
         * @param {number} [pageSize] The maximum size of any individual subset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsGet: async (sportSlug?: string, searchTerm?: string, gender?: string, isArchived?: boolean, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sportSlug !== undefined) {
                localVarQueryParameter['sportSlug'] = sportSlug;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['isArchived'] = isArchived;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search teams.
         * @param {string} [searchTerm] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsSearchGet: async (searchTerm?: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/teams/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a team by identifier.
         * @param {string} teamIdentifier the slug or id of the team to fetch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsTeamIdentifierGet: async (teamIdentifier: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamIdentifier' is not null or undefined
            assertParamExists('teamsTeamIdentifierGet', 'teamIdentifier', teamIdentifier)
            const localVarPath = `/teams/{teamIdentifier}`
                .replace('{teamIdentifier}', encodeURIComponent(String(teamIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamsApi - functional programming interface
 */
export const TeamsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns a list of category objects which potentially represent a country that each contain a list of partnered teams.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teamsCategoriesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryTeamsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teamsCategoriesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.teamsCategoriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list of country objects that each contain a list of partnered teams.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teamsCountriesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CountryTeamsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teamsCountriesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.teamsCountriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary RPC endpoint for fetching teams info from SportMonks for the ML event yield model
         * @param {string} [featuredTeamId] Guid of the featured team
         * @param {string} [participatingTeamId] Guid of the participating team
         * @param {string} [featuredTeamExternalId] SportMonks Id for the featured team
         * @param {string} [participatingTeamExternalId] SportMonks Id for the participating team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teamsEventYieldGet(featuredTeamId?: string, participatingTeamId?: string, featuredTeamExternalId?: string, participatingTeamExternalId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventYieldTeamDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teamsEventYieldGet(featuredTeamId, participatingTeamId, featuredTeamExternalId, participatingTeamExternalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.teamsEventYieldGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all teams for a sport.
         * @param {string} [sportSlug] the slug of the sport for which to get all the teams
         * @param {string} [searchTerm] searchTerm used to filter against team name.
         * @param {string} [gender] 
         * @param {boolean} [isArchived] 
         * @param {number} [offset] The amount of items to skip
         * @param {number} [pageSize] The maximum size of any individual subset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teamsGet(sportSlug?: string, searchTerm?: string, gender?: string, isArchived?: boolean, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfTeamDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teamsGet(sportSlug, searchTerm, gender, isArchived, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.teamsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search teams.
         * @param {string} [searchTerm] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teamsSearchGet(searchTerm?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfTeamDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teamsSearchGet(searchTerm, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.teamsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a team by identifier.
         * @param {string} teamIdentifier the slug or id of the team to fetch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teamsTeamIdentifierGet(teamIdentifier: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teamsTeamIdentifierGet(teamIdentifier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.teamsTeamIdentifierGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamsApi - factory interface
 */
export const TeamsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamsApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns a list of category objects which potentially represent a country that each contain a list of partnered teams.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsCategoriesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<CategoryTeamsDto>> {
            return localVarFp.teamsCategoriesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of country objects that each contain a list of partnered teams.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsCountriesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<CountryTeamsDto>> {
            return localVarFp.teamsCountriesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary RPC endpoint for fetching teams info from SportMonks for the ML event yield model
         * @param {TeamsApiTeamsEventYieldGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsEventYieldGet(requestParameters: TeamsApiTeamsEventYieldGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EventYieldTeamDto> {
            return localVarFp.teamsEventYieldGet(requestParameters.featuredTeamId, requestParameters.participatingTeamId, requestParameters.featuredTeamExternalId, requestParameters.participatingTeamExternalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all teams for a sport.
         * @param {TeamsApiTeamsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsGet(requestParameters: TeamsApiTeamsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfTeamDto> {
            return localVarFp.teamsGet(requestParameters.sportSlug, requestParameters.searchTerm, requestParameters.gender, requestParameters.isArchived, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search teams.
         * @param {TeamsApiTeamsSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsSearchGet(requestParameters: TeamsApiTeamsSearchGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfTeamDto> {
            return localVarFp.teamsSearchGet(requestParameters.searchTerm, requestParameters.offset, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a team by identifier.
         * @param {TeamsApiTeamsTeamIdentifierGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsTeamIdentifierGet(requestParameters: TeamsApiTeamsTeamIdentifierGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamDto> {
            return localVarFp.teamsTeamIdentifierGet(requestParameters.teamIdentifier, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for teamsEventYieldGet operation in TeamsApi.
 */
export interface TeamsApiTeamsEventYieldGetRequest {
    /**
     * Guid of the featured team
     */
    readonly featuredTeamId?: string

    /**
     * Guid of the participating team
     */
    readonly participatingTeamId?: string

    /**
     * SportMonks Id for the featured team
     */
    readonly featuredTeamExternalId?: string

    /**
     * SportMonks Id for the participating team
     */
    readonly participatingTeamExternalId?: string
}

/**
 * Request parameters for teamsGet operation in TeamsApi.
 */
export interface TeamsApiTeamsGetRequest {
    /**
     * the slug of the sport for which to get all the teams
     */
    readonly sportSlug?: string

    /**
     * searchTerm used to filter against team name.
     */
    readonly searchTerm?: string

    readonly gender?: string

    readonly isArchived?: boolean

    /**
     * The amount of items to skip
     */
    readonly offset?: number

    /**
     * The maximum size of any individual subset
     */
    readonly pageSize?: number
}

/**
 * Request parameters for teamsSearchGet operation in TeamsApi.
 */
export interface TeamsApiTeamsSearchGetRequest {
    /**
     * 
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly limit?: number
}

/**
 * Request parameters for teamsTeamIdentifierGet operation in TeamsApi.
 */
export interface TeamsApiTeamsTeamIdentifierGetRequest {
    /**
     * the slug or id of the team to fetch
     */
    readonly teamIdentifier: string
}

/**
 * TeamsApi - object-oriented interface
 */
export class TeamsApi extends BaseAPI {
    /**
     * 
     * @summary Returns a list of category objects which potentially represent a country that each contain a list of partnered teams.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public teamsCategoriesGet(options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).teamsCategoriesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of country objects that each contain a list of partnered teams.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public teamsCountriesGet(options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).teamsCountriesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary RPC endpoint for fetching teams info from SportMonks for the ML event yield model
     * @param {TeamsApiTeamsEventYieldGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public teamsEventYieldGet(requestParameters: TeamsApiTeamsEventYieldGetRequest = {}, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).teamsEventYieldGet(requestParameters.featuredTeamId, requestParameters.participatingTeamId, requestParameters.featuredTeamExternalId, requestParameters.participatingTeamExternalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all teams for a sport.
     * @param {TeamsApiTeamsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public teamsGet(requestParameters: TeamsApiTeamsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).teamsGet(requestParameters.sportSlug, requestParameters.searchTerm, requestParameters.gender, requestParameters.isArchived, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search teams.
     * @param {TeamsApiTeamsSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public teamsSearchGet(requestParameters: TeamsApiTeamsSearchGetRequest = {}, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).teamsSearchGet(requestParameters.searchTerm, requestParameters.offset, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a team by identifier.
     * @param {TeamsApiTeamsTeamIdentifierGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public teamsTeamIdentifierGet(requestParameters: TeamsApiTeamsTeamIdentifierGetRequest, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).teamsTeamIdentifierGet(requestParameters.teamIdentifier, options).then((request) => request(this.axios, this.basePath));
    }
}



